import React, { useState, useEffect } from 'react';
import {
  doc,
  getDoc,
  setDoc,
  arrayUnion,
  updateDoc,
  arrayRemove,
  collection,
  query,
  where,
  getDocs,
  getFirestore,
  deleteDoc,
} from 'firebase/firestore';
import { db } from '../util/firebase';
import { firestore } from '../firebase';
import GameSummary from './GameSummary';
import { isValidGameId } from '../util/api/gameUtils';
import { filterGameData } from '../util/ClipCall';
import { connect } from 'react-redux';
import { getScreams } from '../redux/actions/dataActions';
import { getAuth } from 'firebase/auth';
import { storage } from '../firebase';
import { ref, deleteObject, uploadBytes, getDownloadURL } from 'firebase/storage';
import chessslogo from "../images/chessslogo.png";

const AdminDashboard = (props) => {
  // Tab state - Default to 'profileModeration' or another relevant default if preferred
  const [activeTab, setActiveTab] = useState('spam');

  const user = props?.user?.credentials;
  const db = getFirestore(); // Initialize Firestore

  // New SPAM tab state
  const [spamGames, setSpamGames] = useState([]);
  const [hiddenSpamGames, setHiddenSpamGames] = useState([]);
  const [activeSpamTab, setActiveSpamTab] = useState('main');
  const [dislikeThreshold, setDislikeThreshold] = useState(1);
  const [isLoadingSpam, setIsLoadingSpam] = useState(false);
  const [spamError, setSpamError] = useState(null);
  const [spamContentType, setSpamContentType] = useState('games'); // 'games' or 'comments'

  // Profile Moderation state
  const [pendingProfiles, setPendingProfiles] = useState([]);
  const [isLoadingModeration, setIsLoadingModeration] = useState(false);
  const [moderationError, setModerationError] = useState(null);

  // Admin authentication state
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(true);
  const [loginForm, setLoginForm] = useState({
    username: '',
    password: ''
  });
  const [loginError, setLoginError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  // Check for existing admin token on component mount
  useEffect(() => {
    const checkExistingToken = async () => {
      const token = localStorage.getItem('adminToken');
      if (token) {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL || 'https://api-v7poaqj4ga-uc.a.run.app'}/admin/verify`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (response.ok) {
            setIsAdminAuthenticated(true);
            setShowLoginForm(false);
          } else {
            // Token is invalid, remove it
            localStorage.removeItem('adminToken');
          }
        } catch (error) {
          // // console.error('Token verification failed:', error);
          localStorage.removeItem('adminToken');
        }
      }
    };

    checkExistingToken();
  }, []);

  // Handle admin login
  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setIsLoggingIn(true);
    setLoginError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL || 'https://api-v7poaqj4ga-uc.a.run.app'}/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: loginForm.username,
          password: loginForm.password
        })
      });

      const data = await response.json();

      if (response.ok) {
        // Store the JWT token
        localStorage.setItem('adminToken', data.token);
        setIsAdminAuthenticated(true);
        setShowLoginForm(false);
        setLoginError('');
      } else {
        setLoginError(data.error || 'Authentication failed');
      }
    } catch (error) {
      // // console.error('Login error:', error);
      setLoginError('Network error. Please try again.');
    } finally {
      setIsLoggingIn(false);
    }
  };

  // Handle admin logout
  const handleAdminLogout = () => {
    localStorage.removeItem('adminToken');
    setIsAdminAuthenticated(false);
    setShowLoginForm(true);
    setLoginForm({ username: '', password: '' });
  };

  // Role check is now handled by AdminRoute, so this useEffect is no longer needed
  // useEffect(() => {
  //   if (!isAdminAuthenticated) return; // Don't check role until admin is authenticated

  //   if (!user || Object.keys(user).length === 0) {
  //     return; // Wait if user is empty (initial state)
  //   }

  //   if (!('role' in user) || user.role !== 'Admin') {
  //     window.location = '/'; // Redirect non-admins & users without "role"
  //   }
  // }, [user, isAdminAuthenticated]);

  // Game of the Day state
  const [gameId, setGameId] = useState('');
  const [currentFeaturedId, setCurrentFeaturedId] = useState('');
  const [gameHistory, setGameHistory] = useState([]);
  const [gameDate, setGameDate] = useState(
    new Date().toISOString().split('T')[0],
  ); // Current date in YYYY-MM-DD format
  const [historyDates, setHistoryDates] = useState({});

  // Landing Games state
  const [landingGames, setLandingGames] = useState([]);
  const [newLandingGameId, setNewLandingGameId] = useState('');

  // Featured Creators state
  const [featuredCreators, setFeaturedCreators] = useState([]);
  const [newCreatorHandle, setNewCreatorHandle] = useState('');
  const [newCreatorProfileUrl, setNewCreatorProfileUrl] = useState('');

  // Test Tab 2 state
  const [dailyContentTab, setDailyContentTab] = useState('testTab2');

  // Daily content state
  const [tipOfDay, setTipOfDay] = useState('');
  const [tipNotepad, setTipNotepad] = useState('');
  const [quoteOfDay, setQuoteOfDay] = useState('');
  const [quoteNotepad, setQuoteNotepad] = useState('');
  const [factOfDay, setFactOfDay] = useState('');
  const [factNotepad, setFactNotepad] = useState('');

  // Shared state
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [previewMode, setPreviewMode] = useState(false);

  // Document references
  const featuredGameDocRef = doc(db, 'featuredContent', 'gameOfTheDay');
  const landingGamesDocRef = doc(db, 'featuredContent', 'landingGames');
  const featuredCreatorsDocRef = doc(db, 'featuredContent', 'featuredCreators');
  const tipOfDayDocRef = doc(db, 'featuredContent', 'tipOfTheDay');
  const quoteOfDayDocRef = doc(db, 'featuredContent', 'quoteOfTheDay');
  const factOfDayDocRef = doc(db, 'featuredContent', 'factOfTheDay');

  // Reported comments state
  const [reportedComments, setReportedComments] = useState([]);
  const [hiddenReportedComments, setHiddenReportedComments] = useState([]);
  const [reportThreshold, setReportThreshold] = useState(1);
  const [isLoadingComments, setIsLoadingComments] = useState(false);

  // Fetch data when component loads or active tab changes
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        switch (activeTab) {
          case 'gameOfDay':
            await fetchGameOfDay();
            break;
          case 'landingGames':
            await fetchLandingGames();
            break;
          case 'featuredCreators':
            await fetchFeaturedCreators();
            break;
          case 'spam':
            if (spamContentType === 'games') {
            await fetchSpamGames();
            } else if (spamContentType === 'comments') {
              await fetchReportedComments();
            }
            break;
          case 'profileModeration': // Add case for the new tab
            await fetchPendingProfiles();
            break;
          case 'gameLookup':
            // Reset values when switching to gameLookup tab
            setGameId('');
            setPreviewMode(false);
            setIsLoading(false);
            break;
          case 'testTab2':
            // Fetch daily content when switching to this tab
            await fetchDailyContent();
            break;
          default:
            // Do nothing for test tabs
            setIsLoading(false);
        }
      } catch (err) {
        // console.error('Error fetching data:', err);
        setError('Failed to load data. Please try again.');
        setIsLoading(false);
      }
    };

    fetchData();
  }, [activeTab, spamContentType]); // Add spamContentType as a dependency

  // Fetch Game of the Day data
  const fetchGameOfDay = async () => {
    try {
      const docSnap = await getDoc(featuredGameDocRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setCurrentFeaturedId(data.gameId || '');
        setGameId(data.gameId || '');
        setGameHistory(data.history || []);
        setHistoryDates(data.historyDates || {});
        // Set the date if it exists, otherwise default to today
        setGameDate(data.date || new Date().toISOString().split('T')[0]);
      } else {
        // If document doesn't exist yet, create it with empty gameId
        await setDoc(featuredGameDocRef, {
          gameId: '',
          history: [],
          historyDates: {},
          date: new Date().toISOString().split('T')[0],
          updatedAt: new Date().toISOString(),
        });
        setCurrentFeaturedId('');
        setGameId('');
        setGameHistory([]);
        setHistoryDates({});
        setGameDate(new Date().toISOString().split('T')[0]);
      }
      setIsLoading(false);
    } catch (err) {
      // console.error('Error fetching featured game:', err);
      setError('Failed to load current featured game. Please try again.');
      setIsLoading(false);
    }
  };

  // Fetch Landing Games data
  const fetchLandingGames = async () => {
    try {
      const docSnap = await getDoc(landingGamesDocRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setLandingGames(data.games || []);
      } else {
        // If document doesn't exist yet, create it
        await setDoc(landingGamesDocRef, {
          games: [],
          updatedAt: new Date().toISOString(),
        });
        setLandingGames([]);
      }
      setIsLoading(false);
    } catch (err) {
      // console.error('Error fetching landing games:', err);
      setError('Failed to load landing games. Please try again.');
      setIsLoading(false);
    }
  };

  // Fetch Featured Creators data
  const fetchFeaturedCreators = async () => {
    try {
      const docSnap = await getDoc(featuredCreatorsDocRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setFeaturedCreators(data.creators || []);
      } else {
        // If document doesn't exist yet, create it
        await setDoc(featuredCreatorsDocRef, {
          creators: [],
          updatedAt: new Date().toISOString(),
        });
        setFeaturedCreators([]);
      }
      setIsLoading(false);
    } catch (err) {
      // console.error('Error fetching featured creators:', err);
      setError('Failed to load featured creators. Please try again.');
      setIsLoading(false);
    }
  };

  // Fetch daily content (tip, quote, fact)
  const fetchDailyContent = async () => {
    try {
      // Fetch tip of the day
      const tipDocSnap = await getDoc(tipOfDayDocRef);
      if (tipDocSnap.exists()) {
        const data = tipDocSnap.data();
        setTipOfDay(data.content || '');
        setTipNotepad(data.notepad || '');
      } else {
        // If document doesn't exist yet, create it with empty content
        await setDoc(tipOfDayDocRef, {
          content: '',
          notepad: '',
          updatedAt: new Date().toISOString(),
        });
        setTipOfDay('');
        setTipNotepad('');
      }

      // Fetch quote of the day
      const quoteDocSnap = await getDoc(quoteOfDayDocRef);
      if (quoteDocSnap.exists()) {
        const data = quoteDocSnap.data();
        setQuoteOfDay(data.content || '');
        setQuoteNotepad(data.notepad || '');
      } else {
        // If document doesn't exist yet, create it with empty content
        await setDoc(quoteOfDayDocRef, {
          content: '',
          notepad: '',
          updatedAt: new Date().toISOString(),
        });
        setQuoteOfDay('');
        setQuoteNotepad('');
      }

      // Fetch fact of the day
      const factDocSnap = await getDoc(factOfDayDocRef);
      if (factDocSnap.exists()) {
        const data = factDocSnap.data();
        setFactOfDay(data.content || '');
        setFactNotepad(data.notepad || '');
      } else {
        // If document doesn't exist yet, create it with empty content
        await setDoc(factOfDayDocRef, {
          content: '',
          notepad: '',
          updatedAt: new Date().toISOString(),
        });
        setFactOfDay('');
        setFactNotepad('');
      }

      setIsLoading(false);
    } catch (err) {
      // console.error('Error fetching daily content:', err);
      setError('Failed to load daily content. Please try again.');
      setIsLoading(false);
    }
  };

  // Function to fetch spam games with "dislikeCount" over threshold
  const fetchSpamGames = async () => {
    setIsLoadingSpam(true);
    setSpamError(null);
    try {
      // Create a reference to the games collection
      const gamesRef = collection(firestore, 'games');

      // Get all games (this is a simple approach - for production you'd want pagination)
      const querySnapshot = await getDocs(gamesRef);

      let spamGamesArr = [];
      let hiddenSpamGamesArr = [];

      // Get hidden games IDs from localStorage
      const hiddenGamesStr = localStorage.getItem('hiddenSpamGames');
      const hiddenGamesIds = hiddenGamesStr ? JSON.parse(hiddenGamesStr) : [];

      // Filter games with dislikes >= threshold
      querySnapshot.forEach((doc) => {
        const gameData = doc.data();
        // Check if the game has dislikes array and if the length is >= threshold
        if (gameData.dislikes && gameData.dislikes.length >= dislikeThreshold) {
          const gameWithId = {
            id: doc.id,
            ...gameData,
            dislikeCount: gameData.dislikes ? gameData.dislikes.length : 0,
          };

          // Check if this game is in the hidden list
          if (hiddenGamesIds.includes(doc.id)) {
            hiddenSpamGamesArr.push(gameWithId);
          } else {
            spamGamesArr.push(gameWithId);
          }
        }
      });

      // Sort by number of dislikes (highest first)
      spamGamesArr.sort((a, b) => b.dislikeCount - a.dislikeCount);
      hiddenSpamGamesArr.sort((a, b) => b.dislikeCount - a.dislikeCount);

      setSpamGames(spamGamesArr);
      setHiddenSpamGames(hiddenSpamGamesArr);
      setIsLoadingSpam(false);
      setIsLoading(false);
    } catch (err) {
      // console.error('Error fetching spam games:', err);
      setSpamError('Failed to load spam games. Please try again.');
      setIsLoadingSpam(false);
      setIsLoading(false);
    }
  };

  // Function to fetch profiles needing moderation
  const fetchPendingProfiles = async () => {
    setIsLoadingModeration(true);
    setModerationError(null);
    setPendingProfiles([]); // Clear previous results

    try {
      const usersRef = collection(firestore, 'users');
      
      // Create two queries: one for needsModeration flag, one for pendingPhotoUrl
      const needsModerationQuery = query(usersRef, where('needsModeration', '==', true));
      const pendingPhotoQuery = query(usersRef, where('pendingPhotoUrl', '!=', null));
      
      // Execute both queries
      const [needsModerationSnapshot, pendingPhotoSnapshot] = await Promise.all([
        getDocs(needsModerationQuery),
        getDocs(pendingPhotoQuery)
      ]);

      // Combined results map to avoid duplicates (using document ID as key)
      const profilesMap = new Map();
      
      // Process profiles needing general moderation
      needsModerationSnapshot.forEach((doc) => {
        const docData = doc.data();
        profilesMap.set(doc.id, { 
          id: doc.id, 
          credentials: docData,
          pendingPhotoUrl: docData.pendingPhotoUrl || null,
          photoUrl: docData.photoUrl || null 
        });
      });
      
      // Process profiles with pending photo URLs
      pendingPhotoSnapshot.forEach((doc) => {
        const docData = doc.data();
        // If already in map, just ensure pendingPhotoUrl is set
        if (profilesMap.has(doc.id)) {
          const existingData = profilesMap.get(doc.id);
          existingData.pendingPhotoUrl = docData.pendingPhotoUrl;
          existingData.photoUrl = docData.photoUrl || null;
        } else {
          // Otherwise add new entry
          profilesMap.set(doc.id, { 
            id: doc.id, 
            credentials: docData,
            pendingPhotoUrl: docData.pendingPhotoUrl,
            photoUrl: docData.photoUrl || null 
          });
        }
      });
      
      // Convert map to array for state
      const profiles = Array.from(profilesMap.values());
      
      setPendingProfiles(profiles);
      // Debug log

    } catch (err) {
      // console.error('Error fetching pending profiles:', err);
      setModerationError('Failed to load profiles needing moderation. Please try again.');
    } finally {
      setIsLoadingModeration(false);
      setIsLoading(false); // Ensure main loading indicator is also turned off
    }
  };

  // Function to handle removing a game from the database
  const handleRemoveGameFromDatabase = async (gameId) => {
    try {
      if (
        !window.confirm(
          'Are you sure you want to PERMANENTLY DELETE this game from the database? This action cannot be undone.',
        )
      ) {
        return;
      }

      setIsLoadingSpam(true);

      // Delete the game document
      await deleteDoc(doc(firestore, 'games', gameId));

      // Update local state
      setSpamGames((prevGames) =>
        prevGames.filter((game) => game.id !== gameId),
      );
      setHiddenSpamGames((prevGames) =>
        prevGames.filter((game) => game.id !== gameId),
      );

      // Show success message
      setSuccessMessage('Game permanently deleted from database!');

      // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);

      setIsLoadingSpam(false);
    } catch (err) {
      // console.error('Error removing game from database:', err);
      setSpamError('Failed to delete game. Please try again.');
      setIsLoadingSpam(false);
    }
  };

  // Function to hide a game from the main spam view
  const handleHideFromSpamView = (gameId) => {
    try {
      // Get current hidden games
      const hiddenGamesStr = localStorage.getItem('hiddenSpamGames');
      const hiddenGamesIds = hiddenGamesStr ? JSON.parse(hiddenGamesStr) : [];

      // Add the game ID to hidden games
      const updatedHiddenGames = [...hiddenGamesIds, gameId];

      // Save back to localStorage
      localStorage.setItem(
        'hiddenSpamGames',
        JSON.stringify(updatedHiddenGames),
      );

      // Move the game from spam to hidden
      const gameToHide = spamGames.find((game) => game.id === gameId);
      if (gameToHide) {
        setHiddenSpamGames((prev) => [...prev, gameToHide]);
        setSpamGames((prev) => prev.filter((game) => game.id !== gameId));
      }

      // Show success message
      setSuccessMessage('Game hidden from main spam view!');

      // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error hiding game:', err);
      setSpamError('Failed to hide game. Please try again.');
    }
  };

  // Function to unhide a game from the hidden spam view
  const handleUnhideFromSpamView = (gameId) => {
    try {
      // Get current hidden games
      const hiddenGamesStr = localStorage.getItem('hiddenSpamGames');
      const hiddenGamesIds = hiddenGamesStr ? JSON.parse(hiddenGamesStr) : [];

      // Remove the game ID from hidden games
      const updatedHiddenGames = hiddenGamesIds.filter((id) => id !== gameId);

      // Save back to localStorage
      localStorage.setItem(
        'hiddenSpamGames',
        JSON.stringify(updatedHiddenGames),
      );

      // Move the game from hidden to spam
      const gameToUnhide = hiddenSpamGames.find((game) => game.id === gameId);
      if (gameToUnhide) {
        setSpamGames((prev) => [...prev, gameToUnhide]);
        setHiddenSpamGames((prev) => prev.filter((game) => game.id !== gameId));
      }

      // Show success message
      setSuccessMessage('Game restored to main spam view!');

      // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error unhiding game:', err);
      setSpamError('Failed to unhide game. Please try again.');
    }
  };

  // Handle form submission to update the Game of the Day
  const handleGameOfDaySubmit = async (e) => {
    e.preventDefault();

    // Clear any previous messages
    setError(null);
    setSuccessMessage('');

    // Validate the game ID
    if (!isValidGameId(gameId)) {
      setError('Please enter a valid game ID (UUID format)');
      return;
    }

    // Check if it's the same as the current game
    if (gameId === currentFeaturedId) {
      setError('This game is already the Game of the Day');
      return;
    }

    try {
      setIsLoading(true);

      // Fetch the current document first to get the existing historyDates
      const docSnap = await getDoc(featuredGameDocRef);
      let historyDates = {};
      let currentHistory = [];

      if (docSnap.exists()) {
        const data = docSnap.data();
        historyDates = data.historyDates || {};
        currentHistory = data.history || [];
      }

      // Add the current date to historyDates for the new game
      historyDates[gameId] = gameDate;

      // Add the current featured game to history if it exists
      if (currentFeaturedId && !currentHistory.includes(currentFeaturedId)) {
        currentHistory.push(currentFeaturedId);
      }

      // Make sure the new game is not in history (to avoid duplicates)
      const updatedHistory = currentHistory.filter((id) => id !== gameId);

      // Sort history by date (most recent first)
      // Convert date strings to Date objects for proper comparison
      updatedHistory.sort((idA, idB) => {
        const dateA = historyDates[idA]
          ? new Date(historyDates[idA])
          : new Date(0);
        const dateB = historyDates[idB]
          ? new Date(historyDates[idB])
          : new Date(0);
        return dateB - dateA; // Most recent first
      });

      // Update the featured game document
      await setDoc(featuredGameDocRef, {
        gameId: gameId,
        history: updatedHistory,
        historyDates: historyDates,
        date: gameDate,
        updatedAt: new Date().toISOString(),
        updatedBy: 'admin',
      });

      setCurrentFeaturedId(gameId);
      setGameHistory(updatedHistory);
      setHistoryDates(historyDates);
      setSuccessMessage('Game of the Day updated successfully!');
      setIsLoading(false);

      // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error updating featured game:', err);
      setError('Failed to update featured game. Please try again.');
      setIsLoading(false);
    }
  };

  // Handle form submission to add a Landing Game
  const handleLandingGamesSubmit = async (e) => {
    e.preventDefault();

    // Clear any previous messages
    setError(null);
    setSuccessMessage('');

    // Validate the game ID
    if (!isValidGameId(newLandingGameId)) {
      setError('Please enter a valid game ID (UUID format)');
      return;
    }

    // Check if it's already in the list
    if (landingGames.includes(newLandingGameId)) {
      setError('This game is already in the Landing Games list');
      return;
    }

    try {
      setIsLoading(true);

      // Add the new game to the array
      const updatedGames = [...landingGames, newLandingGameId];

      // Update the document
      await setDoc(landingGamesDocRef, {
        games: updatedGames,
        updatedAt: new Date().toISOString(),
        updatedBy: 'admin',
      });

      setLandingGames(updatedGames);
      setNewLandingGameId(''); // Clear the input
      setSuccessMessage('Landing game added successfully!');
      setIsLoading(false);

      // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error adding landing game:', err);
      setError('Failed to add landing game. Please try again.');
      setIsLoading(false);
    }
  };

  // Handle removing a game from Landing Games
  const handleRemoveLandingGame = async (gameIdToRemove) => {
    try {
      setIsLoading(true);

      // Remove the game from the array
      const updatedGames = landingGames.filter((id) => id !== gameIdToRemove);

      // Update the document
      await setDoc(landingGamesDocRef, {
        games: updatedGames,
        updatedAt: new Date().toISOString(),
        updatedBy: 'admin',
      });

      setLandingGames(updatedGames);
      setSuccessMessage('Game removed successfully!');
      setIsLoading(false);

      // Auto-hide success message
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error removing game:', err);
      setError('Failed to remove game. Please try again.');
      setIsLoading(false);
    }
  };

  // Handle form submission to add a Featured Creator
  const handleFeaturedCreatorsSubmit = async (e) => {
    e.preventDefault();

    // Clear any previous messages
    setError(null);
    setSuccessMessage('');

    // Validate the creator handle
    if (!newCreatorHandle) {
      setError('Please enter a creator handle');
      return;
    }

    // Check if handle already exists
    if (
      featuredCreators.some(
        (creator) => creator.username === `@${newCreatorHandle}`,
      )
    ) {
      setError('This creator is already in the Featured Creators list');
      return;
    }

    try {
      setIsLoading(true);

      // Create the new creator object
      const newCreator = {
        username: `@${newCreatorHandle}`,
        profileUrl: newCreatorProfileUrl || `/profile/${newCreatorHandle}`,
        isFollowing: false,
      };

      // Add the new creator to the array
      const updatedCreators = [...featuredCreators, newCreator];

      // Update the document
      await setDoc(featuredCreatorsDocRef, {
        creators: updatedCreators,
        updatedAt: new Date().toISOString(),
        updatedBy: 'admin',
      });

      setFeaturedCreators(updatedCreators);
      setNewCreatorHandle(''); // Clear the inputs
      setNewCreatorProfileUrl('');
      setSuccessMessage('Creator added successfully!');
      setIsLoading(false);

      // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error adding creator:', err);
      setError('Failed to add creator. Please try again.');
      setIsLoading(false);
    }
  };

  // Handle removing a creator from Featured Creators
  const handleRemoveCreator = async (creatorUsername) => {
    try {
      setIsLoading(true);

      // Remove the creator from the array
      const updatedCreators = featuredCreators.filter(
        (creator) => creator.username !== creatorUsername,
      );

      // Update the document
      await setDoc(featuredCreatorsDocRef, {
        creators: updatedCreators,
        updatedAt: new Date().toISOString(),
        updatedBy: 'admin',
      });

      setFeaturedCreators(updatedCreators);
      setSuccessMessage('Creator removed successfully!');
      setIsLoading(false);

      // Auto-hide success message
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error removing creator:', err);
      setError('Failed to remove creator. Please try again.');
      setIsLoading(false);
    }
  };

  // Add a test game to game of the day history (utility function for testing)
  const addTestGame = async () => {
    try {
      setIsLoading(true);

      // Add a test game to the history
      await updateDoc(featuredGameDocRef, {
        history: arrayUnion('134096f0-807e-4df4-8e0b-3b7f261ce880'),
      });

      // Refresh the data
      await fetchGameOfDay();

      setSuccessMessage('Test game added to history!');
      setIsLoading(false);

      // Auto-hide success message
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error adding test game:', err);
      setError('Failed to add test game. Please try again.');
      setIsLoading(false);
    }
  };

  // Toggle preview mode
  const togglePreview = () => {
    setPreviewMode(!previewMode);
  };

  // Handle removing a game from history
  const handleRemoveGameFromHistory = async (gameIdToRemove) => {
    try {
      setIsLoading(true);
      setError(null);

      // First check if it's the current featured game
      if (gameIdToRemove === currentFeaturedId) {
        setError('Cannot remove the current Game of the Day from history');
        setIsLoading(false);
        return;
      }

      // Get the current document to make sure we have the latest data
      const docSnap = await getDoc(featuredGameDocRef);
      let updatedHistoryDates = { ...historyDates };

      // Remove the date entry for this game
      delete updatedHistoryDates[gameIdToRemove];

      // Remove the game from the history array and update historyDates
      await updateDoc(featuredGameDocRef, {
        history: arrayRemove(gameIdToRemove),
        historyDates: updatedHistoryDates,
        updatedAt: new Date().toISOString(),
      });

      // Update local state to reflect the changes
      setGameHistory((prevHistory) =>
        prevHistory.filter((id) => id !== gameIdToRemove),
      );
      setHistoryDates(updatedHistoryDates);
      setSuccessMessage('Game removed from history successfully!');

      // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);

      setIsLoading(false);
    } catch (err) {
      // console.error('Error removing game from history:', err);
      setError('Failed to remove game from history. Please try again.');
      setIsLoading(false);
    }
  };

  // Handle form submission to update the Tip of the Day
  const handleTipOfDaySubmit = async (e) => {
    e.preventDefault();

    // Clear any previous messages
    setError(null);
    setSuccessMessage('');

    try {
      setIsLoading(true);

      // Update the tip of the day document
      await setDoc(tipOfDayDocRef, {
        content: tipOfDay,
        notepad: tipNotepad,
        updatedAt: new Date().toISOString(),
        updatedBy: 'admin',
      });

      setSuccessMessage('Tip of the Day updated successfully!');
      setIsLoading(false);

      // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error updating tip of the day:', err);
      setError('Failed to update tip of the day. Please try again.');
      setIsLoading(false);
    }
  };

  // Handle form submission to update the Quote of the Day
  const handleQuoteOfDaySubmit = async (e) => {
    e.preventDefault();

    // Clear any previous messages
    setError(null);
    setSuccessMessage('');

    try {
      setIsLoading(true);

      // Update the quote of the day document
      await setDoc(quoteOfDayDocRef, {
        content: quoteOfDay,
        notepad: quoteNotepad,
        updatedAt: new Date().toISOString(),
        updatedBy: 'admin',
      });

      setSuccessMessage('Quote of the Day updated successfully!');
      setIsLoading(false);

      // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error updating quote of the day:', err);
      setError('Failed to update quote of the day. Please try again.');
      setIsLoading(false);
    }
  };

  // Handle form submission to update the Fact of the Day
  const handleFactOfDaySubmit = async (e) => {
    e.preventDefault();

    // Clear any previous messages
    setError(null);
    setSuccessMessage('');

    try {
      setIsLoading(true);

      // Update the fact of the day document
      await setDoc(factOfDayDocRef, {
        content: factOfDay,
        notepad: factNotepad,
        updatedAt: new Date().toISOString(),
        updatedBy: 'admin',
      });

      setSuccessMessage('Fact of the Day updated successfully!');
      setIsLoading(false);

      // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      // console.error('Error updating fact of the day:', err);
      setError('Failed to update fact of the day. Please try again.');
      setIsLoading(false);
    }
  };

  // Add this function after other handler functions
  const handleOpenGameInNewTab = (gameId) => {
    window.open(`/games/${gameId}`, '_blank');
  };

  // --- Profile Moderation Handlers ---

  // Handle approving a specific field
  const handleApproveField = async (userId, fieldName) => {
    // Debug log
    setError(null); // Clear previous specific errors if any
    setSuccessMessage('');

    const userProfile = pendingProfiles.find(p => p.id === userId);
    if (!userProfile) {
      // console.error("User profile not found in state for ID:", userId);
      setModerationError("Could not find user data to approve.");
      return;
    }

    const credentials = userProfile.credentials;
    const pendingFieldName = `pending${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}`;

    // Handle potential case inconsistencies in the pending field name
    let correctedPendingFieldName = pendingFieldName;
    if (pendingFieldName === 'pendingYoutubelink') {
      correctedPendingFieldName = 'pendingYoutubeLink';
    } else if (pendingFieldName === 'pendingTiktoklink') {
      correctedPendingFieldName = 'pendingTikTokLink';
    } else if (pendingFieldName === 'pendingInstagramlink') {
      correctedPendingFieldName = 'pendingInstagramLink';
    } else if (pendingFieldName === 'pendingTwitterlink') {
      correctedPendingFieldName = 'pendingTwitterLink';
    }

    if (!(correctedPendingFieldName in credentials)) {
      // console.error(`Pending field ${correctedPendingFieldName} does not exist on user ${userId}`);
      setModerationError(`Data structure error: Pending field ${correctedPendingFieldName} missing.`);
      return;
    }

    const pendingArray = credentials[correctedPendingFieldName];

    // Validate that it's an array [value, false]
    if (!Array.isArray(pendingArray) || pendingArray.length !== 2 || pendingArray[1] !== false) {
      // console.warn(`Invalid or already processed pending data found for ${correctedPendingFieldName} on user ${userId}. Data:`, pendingArray);
      setModerationError(`Unexpected data format for ${fieldName}. Cannot approve.`);
      setTimeout(() => setModerationError(null), 5000);
      return;
    }

    const pendingValue = pendingArray[0]; // Get the actual value from the array

    // --- TikTok Field Name Check ---
    // Explicitly handle potential inconsistency in TikTok field name
    // Convert the input fieldName (e.g., 'tiktoklink') to the expected main field name in Firestore
    let mainFieldName = fieldName.toLowerCase();
    if (mainFieldName === 'tiktoklink') {
      mainFieldName = 'tiktokLink';
    } else if (mainFieldName === 'youtubelink') {
      mainFieldName = 'youtubeLink';
    } else if (mainFieldName === 'instagramlink') {
      mainFieldName = 'instagramLink';
    } else if (mainFieldName === 'twitterlink') {
      mainFieldName = 'twitterLink';
    }
    // Add similar checks if other field names might be inconsistent (e.g., biography vs Biography)
    else if (mainFieldName === 'biography') {
      mainFieldName = 'biography'; // Assuming Firestore uses lowercase
    } else if (mainFieldName === 'status') {
      mainFieldName = 'status'; // Assuming Firestore uses lowercase
    }

    // Prepare the update payload
    const updateData = {
      [mainFieldName]: pendingValue, // Update the main 'safe' field
      [correctedPendingFieldName]: null,      // Clear the pending field using the corrected name
    };

    // Check if other pending fields still need moderation
    let otherPendingExists = false;
    const fieldsToCheck = ['Status', 'Biography', 'YoutubeLink', 'TikTokLink', 'InstagramLink', 'TwitterLink'];
    fieldsToCheck.forEach(f => {
      const checkPendingField = `pending${f}`;
      // Check if the field exists, is an array, and has 'false' as the second element
      if (
        checkPendingField !== correctedPendingFieldName &&
        credentials[checkPendingField] !== null &&
        credentials[checkPendingField] !== undefined &&
        Array.isArray(credentials[checkPendingField]) &&
        credentials[checkPendingField][1] === false
      ) {
        otherPendingExists = true;
      }
    });

    // If no other pending fields have values, set needsModeration to false
    if (!otherPendingExists) {
      updateData.needsModeration = false;
    } else {
      updateData.needsModeration = true; // Explicitly keep it true if others remain
    }


    try {
      setIsLoadingModeration(true);
      const userDocRef = doc(firestore, 'users', userId);
      await updateDoc(userDocRef, updateData);

      setSuccessMessage(`${fieldName} approved successfully for user ${userProfile.credentials.handle || userId}!`);
      // Refresh the data to reflect the change
      await fetchPendingProfiles();

      // Auto-hide success message
      setTimeout(() => setSuccessMessage(''), 4000);

    } catch (err) {
      // console.error(`Error approving ${fieldName} for user ${userId}:`, err);
      setModerationError(`Failed to approve ${fieldName}. Please try again.`);
      // Auto-hide error message
      setTimeout(() => setModerationError(null), 5000);
    } finally {
      // Ensure loading is stopped even if refresh hasn't fully completed state update yet
      // This might cause a brief flicker, but prevents getting stuck in loading
      setIsLoadingModeration(false);
    }
  };

  // (Optional) Handle rejecting a specific field
  const handleRejectField = async (userId, fieldName) => {
    
    setError(null);
    setSuccessMessage('');


    const userProfile = pendingProfiles.find(p => p.id === userId);
    if (!userProfile) {
      // console.error("User profile not found in state for ID:", userId);
      setModerationError("Could not find user data to reject.");
      return;
    }

    const credentials = userProfile.credentials;
    const pendingFieldName = `pending${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}`;

    // Handle potential case inconsistencies
    let correctedPendingFieldName = pendingFieldName;
    if (pendingFieldName === 'pendingYoutubelink') {
      correctedPendingFieldName = 'pendingYoutubeLink';
    } else if (pendingFieldName === 'pendingTiktoklink') {
      correctedPendingFieldName = 'pendingTikTokLink';
    } else if (pendingFieldName === 'pendingInstagramlink') {
      correctedPendingFieldName = 'pendingInstagramLink';
    } else if (pendingFieldName === 'pendingTwitterlink') {
      correctedPendingFieldName = 'pendingTwitterLink';
    }

    if (!(correctedPendingFieldName in credentials)) {
      // console.error(`Pending field ${correctedPendingFieldName} does not exist on user ${userId}`);
      setModerationError(`Data structure error: Pending field ${correctedPendingFieldName} missing.`);
      return;
    }

    // Ensure there is actually something to reject (it should be an array [value, false])
    const pendingArray = credentials[correctedPendingFieldName];
    if (!Array.isArray(pendingArray) || pendingArray.length !== 2 || pendingArray[1] !== false) {
      // console.warn(`Cannot reject field ${correctedPendingFieldName} for user ${userId} - data is not in pending state:`, pendingArray);
      // Optionally show a message, but likely just return as there's nothing to reject
      return;
    }

    // Prepare the update payload - just clear the pending field by setting it to null
    const updateData = {
      [correctedPendingFieldName]: null,
    };

    // Check if other pending fields still need moderation
    let otherPendingExists = false;
    const fieldsToCheck = ['Status', 'Biography', 'YoutubeLink', 'TikTokLink', 'InstagramLink', 'TwitterLink'];
    fieldsToCheck.forEach(f => {
      const checkPendingField = `pending${f}`;
      if (
        checkPendingField !== correctedPendingFieldName &&
        credentials[checkPendingField] !== null &&
        credentials[checkPendingField] !== undefined &&
        Array.isArray(credentials[checkPendingField]) &&
        credentials[checkPendingField][1] === false
      ) {
        otherPendingExists = true;
      }
    });

    if (!otherPendingExists) {
      updateData.needsModeration = false;
    } else {
      updateData.needsModeration = true;
    }

    try {
      setIsLoadingModeration(true);
      const userDocRef = doc(firestore, 'users', userId);
      await updateDoc(userDocRef, updateData);

      setSuccessMessage(`${fieldName} rejected successfully for user ${userProfile.credentials.handle || userId}.`);
      await fetchPendingProfiles(); // Refresh

      setTimeout(() => setSuccessMessage(''), 4000);

    } catch (err) {
      // console.error(`Error rejecting ${fieldName} for user ${userId}:`, err);
      setModerationError(`Failed to reject ${fieldName}. Please try again.`);
      setTimeout(() => setModerationError(null), 5000);
    } finally {
      setIsLoadingModeration(false);
    }
  };

  // New function to handle approving all fields for a single user
  const handleApproveAllFields = async (userId, userProfile) => {
    
    setError(null);
    setSuccessMessage('');

    // Loading state
    setIsLoadingModeration(true);

    const fieldKeys = ['Status', 'Biography', 'YoutubeLink', 'TikTokLink', 'InstagramLink', 'TwitterLink'];
    const credentials = userProfile.credentials;
    const updateData = {};
    let updateCount = 0;

    // Prepare all updates in one object
    for (const fieldKey of fieldKeys) {
      const pendingField = `pending${fieldKey}`;
      const lowerFieldKey = fieldKey.toLowerCase();

      // Handle potential case inconsistencies
      let mainField = lowerFieldKey;
      if (lowerFieldKey === 'tiktoklink') mainField = 'tiktokLink';
      else if (lowerFieldKey === 'youtubelink') mainField = 'youtubeLink';
      else if (lowerFieldKey === 'instagramlink') mainField = 'instagramLink';
      else if (lowerFieldKey === 'twitterlink') mainField = 'twitterLink';

      // Check if field exists and is pending
      const pendingData = credentials[pendingField];
      if (pendingData && Array.isArray(pendingData) && pendingData.length === 2 && pendingData[1] === false) {
        updateData[mainField] = pendingData[0]; // Set main field to pending value
        updateData[pendingField] = null;        // Clear pending field
        updateCount++;
      }
    }

    // Also handle pending profile picture if it exists
    if (userProfile.pendingPhotoUrl) {
      updateData.photoUrl = userProfile.pendingPhotoUrl;
      updateData.pendingPhotoUrl = null;
      updateCount++;
    }

    // If nothing to update, exit early
    if (updateCount === 0) {
      setIsLoadingModeration(false);
      setModerationError("No pending fields found to approve.");
      setTimeout(() => setModerationError(null), 5000);
      return;
    }

    // Set needsModeration to false since we're approving all fields
    updateData.needsModeration = false;

    try {
      // Perform single Firestore update with all field changes
      const userDocRef = doc(firestore, 'users', userId);
      await updateDoc(userDocRef, updateData);

      setSuccessMessage(`Successfully approved all ${updateCount} pending fields for user ${userProfile.credentials?.handle || userId}!`);
      await fetchPendingProfiles(); // Refresh the data

      // Auto-hide success message
      setTimeout(() => setSuccessMessage(''), 4000);
    } catch (err) {
      // console.error(`Error approving all fields for user ${userId}:`, err);
      setModerationError(`Failed to approve all fields. Please try again.`);
      setTimeout(() => setModerationError(null), 5000);
    } finally {
      setIsLoadingModeration(false);
    }
  };

  // New function to handle rejecting all fields for a single user
  const handleRejectAllFields = async (userId, userProfile) => {
    
    setError(null);
    setSuccessMessage('');

    // Loading state
    setIsLoadingModeration(true);

    const fieldKeys = ['Status', 'Biography', 'YoutubeLink', 'TikTokLink', 'InstagramLink', 'TwitterLink'];
    const credentials = userProfile.credentials;
    const updateData = {};
    let updateCount = 0;

    // Prepare all updates in one object
    for (const fieldKey of fieldKeys) {
      const pendingField = `pending${fieldKey}`;

      // Check if field exists and is pending
      const pendingData = credentials[pendingField];
      if (pendingData && Array.isArray(pendingData) && pendingData.length === 2 && pendingData[1] === false) {
        updateData[pendingField] = null;  // Clear pending field without setting the main field
        updateCount++;
      }
    }

    // Also handle pending profile picture if it exists
    if (userProfile.pendingPhotoUrl) {
      try {
        // Try to delete the pending image from storage
        const pendingPhotoUrl = userProfile.pendingPhotoUrl;
        const url = new URL(pendingPhotoUrl);
        const path = url.pathname.split('/o/')[1];
        if (path) {
          const decodedPath = decodeURIComponent(path.split('?')[0]);
          const pendingImageRef = ref(storage, decodedPath);
          await deleteObject(pendingImageRef);
          
        }
      } catch (storageError) {
        // console.error('Error deleting photo from storage during batch rejection:', storageError);
        // Continue with the rejection even if storage deletion fails
      }
      
      updateData.pendingPhotoUrl = null;
      updateCount++;
    }

    // If nothing to update, exit early
    if (updateCount === 0) {
      setIsLoadingModeration(false);
      setModerationError("No pending fields found to reject.");
      setTimeout(() => setModerationError(null), 5000);
      return;
    }

    // Set needsModeration to false since we're handling all fields
    updateData.needsModeration = false;

    try {
      // Perform single Firestore update with all field changes
      const userDocRef = doc(firestore, 'users', userId);
      await updateDoc(userDocRef, updateData);

      setSuccessMessage(`Successfully rejected all ${updateCount} pending fields for user ${userProfile.credentials?.handle || userId}!`);
      await fetchPendingProfiles(); // Refresh the data

      // Auto-hide success message
      setTimeout(() => setSuccessMessage(''), 4000);
    } catch (err) {
      // console.error(`Error rejecting all fields for user ${userId}:`, err);
      setModerationError(`Failed to reject all fields. Please try again.`);
      setTimeout(() => setModerationError(null), 5000);
    } finally {
      setIsLoadingModeration(false);
    }
  };

  const handleTransformClick = () => {
    // Get the current user from Firebase Auth
    const auth = getAuth();
    const currentUser = auth.currentUser;

    // Fetch the game data and log it to console
    const gameRef = doc(db, 'games', gameId);
    getDoc(gameRef)
      .then((gameDoc) => {
        if (gameDoc.exists()) {
          const gameData = gameDoc.data();
          const filteredData = filterGameData
            ? filterGameData(gameData)
            : gameData;

          // Accessing specific data
          const arrowsAndSquares = filteredData.arrowsAndSquares || [];
          const originalMoves = filteredData.originalMoves || [];
          const pgn = filteredData.pgn || '';
          const videoTitle =

            filteredData.videoTitle || 'ChessThread.com';

          const gameFen = filteredData.fen || '';

      


          const transformedData = {
            takeScreenShot: false,
            videoUrl: '',
            isCapturingComplete: false,
            moves: originalMoves.map((move) => move.notation),
            frameRate: 1,
            startFrame: 1,
            endFrame: originalMoves.length,
            gameFen:gameFen,
            framesWithCustomPause: {},
            allFrameslength: {},
            ColoredMoves: [
              {
                move: 'New Game',
                color: '',
                Index: 0,
                description: '',
                time: 1,
                descriptionColor: '#ffffff',
                highlightedSquares: {}, // Avoid nested arrays
                arrows: [], // Avoid nested arrays
              },
              ...originalMoves.map((move, index) => {
                const arrowsAndSquaresForMove = arrowsAndSquares[index] || {};
                const highlightedSquares =
                  arrowsAndSquaresForMove.highlights &&
                    !Array.isArray(arrowsAndSquaresForMove.highlights)
                    ? arrowsAndSquaresForMove.highlights
                    : {};

                const arrows = arrowsAndSquaresForMove.arrows || [];

                // Transforming arrows to an object with explicit arrow names
                const formattedArrows = arrows.reduce(
                  (acc, arrow, arrowIndex) => {
                    acc[`arrow${arrowIndex + 1}`] = {
                      from: arrow[0],
                      to: arrow[1],
                      color: arrow[2],
                    };
                    return acc;
                  },
                  {},
                );

                return {
                  move: move.notation,
                  color: index % 2 === 0 ? 'White' : 'Black',
                  time: 1,
                  Index: index + 1,
                  description: move.content || "",
                  descriptionColor: '#ffffff',
                  highlightedSquares: highlightedSquares,

                  arrows: formattedArrows, 
                  gameFen:gameFen,

                };
              }),
            ],
            copyOfMoves: [
              'New Game',
              ...originalMoves.map((move) => move.notation),
            ],
            isFlipped: false,
            gameName: '',
            signedInUser: {
              name: currentUser.displayName || 'Anonymous',
              role: 'admin',
              uid: currentUser.uid,
              videoCount: 0,
              subscriptionStatus: 'inActive',
              gamesCount: 1,
            },
            pgn: pgn || '',
            videoTitle: videoTitle,
            fontType: 'Original',
            fontColor: 'green',
            aspectRatio: '9:16',
            Url: '',
          };

          

          const newCollectionName = 'chessSocialGames';
          const gameDocRef = doc(db, newCollectionName, gameId);

          setDoc(gameDocRef, transformedData)
            .then(() => {
              
              setSuccessMessage('Game data saved successfully!');
              setTimeout(() => {
                setSuccessMessage('');
              }, 3000);
              window.open(
                `http://chessclip.io/auth/login?gameId=${gameId}&uid=${currentUser.uid}&fen=${encodeURIComponent(gameFen)}`,
                "_blank"
              );              
            })
            .catch((error) => {
              // console.error('Error saving game data:', error);
              setError('Failed to save game data. Please try again.');
              setTimeout(() => {
                setError('');
              }, 3000);
            });
        } else {
          setError(`Game with ID ${gameId} not found.`);
          setTimeout(() => {
            setError('');
          }, 3000);
        }
      })
      .catch((err) => {
        // console.error('Error fetching game data:', err);
        setError('Failed to fetch game data. Please try again.');
        setTimeout(() => {
          setError('');
        }, 3000);
      });
  };

  // Function to fetch reported comments with reports >= threshold
  const fetchReportedComments = async () => {
    setIsLoadingComments(true);
    setSpamError(null);

    try {
      // Create a reference to the games collection
      const gamesRef = collection(db, 'games');
      
      // Get all games
      const querySnapshot = await getDocs(gamesRef);

      let reportedCommentsArr = [];
      let hiddenReportedCommentsArr = [];

      // Get hidden comments IDs from localStorage
      const hiddenCommentsStr = localStorage.getItem('hiddenReportedComments');
      const hiddenCommentsIds = hiddenCommentsStr ? JSON.parse(hiddenCommentsStr) : [];

      // Process each game document
      querySnapshot.forEach((doc) => {
        const gameData = doc.data();
        const gameId = doc.id;
        
        // Check if the game has comments
        if (gameData.comments && Array.isArray(gameData.comments)) {
          // Go through each comment in the game
          gameData.comments.forEach((comment, commentIndex) => {
            // Check if comment has reports and meets threshold
            if (comment.reports && comment.reports.length >= reportThreshold) {
              const commentWithMetadata = {
                ...comment,
                gameId: gameId,          // Store which game this comment belongs to
                commentIndex: commentIndex, // Store the index of this comment in the game's comments array
                reportCount: comment.reports.length,
                uniqueId: `${gameId}_${commentIndex}` // Create a unique ID for the comment
              };

              // Check if this comment is in the hidden list
              if (hiddenCommentsIds.includes(commentWithMetadata.uniqueId)) {
                hiddenReportedCommentsArr.push(commentWithMetadata);
              } else {
                reportedCommentsArr.push(commentWithMetadata);
              }
            }
          });
        }
      });

      // Sort by number of reports (highest first)
      reportedCommentsArr.sort((a, b) => b.reportCount - a.reportCount);
      hiddenReportedCommentsArr.sort((a, b) => b.reportCount - a.reportCount);

      setReportedComments(reportedCommentsArr);
      setHiddenReportedComments(hiddenReportedCommentsArr);
      
      
      
      setIsLoadingComments(false);
      setIsLoading(false);
    } catch (err) {
      // console.error('Error fetching reported comments:', err);
      setSpamError('Failed to load reported comments. Please try again.');
      setIsLoadingComments(false);
      setIsLoading(false);
    }
  };

  // Function to handle removing a comment from a game in the database
  const handleRemoveCommentFromDatabase = async (gameId, commentIndex) => {
    // Confirm deletion to prevent accidental removals
    if (!window.confirm('Are you sure you want to permanently delete this comment?')) {
      return;
    }

    try {
      setIsLoadingComments(true);

      // Get the game document
      const gameDocRef = doc(db, 'games', gameId);
      const gameSnapshot = await getDoc(gameDocRef);

      if (!gameSnapshot.exists()) {
        setSpamError('Game not found. Cannot delete comment.');
        setIsLoadingComments(false);
        return;
      }

      const gameData = gameSnapshot.data();
      
      // Check if comments array exists and the index is valid
      if (!gameData.comments || !Array.isArray(gameData.comments) || commentIndex >= gameData.comments.length) {
        setSpamError('Invalid comment index or comments array not found.');
        setIsLoadingComments(false);
        return;
      }

      // Create a new comments array without the comment to be removed
      const updatedComments = [
        ...gameData.comments.slice(0, commentIndex),
        ...gameData.comments.slice(commentIndex + 1)
      ];

      // Update the game document with the new comments array
      await updateDoc(gameDocRef, {
        comments: updatedComments
      });

      // Update local state by removing the comment
      const uniqueId = `${gameId}_${commentIndex}`;
      setReportedComments(prevComments => 
        prevComments.filter(comment => comment.uniqueId !== uniqueId)
      );

      // Show success message
      setSuccessMessage('Comment successfully removed from database');
      setTimeout(() => setSuccessMessage(''), 3000);
      
      setIsLoadingComments(false);
    } catch (error) {
      // console.error('Error removing comment:', error);
      setSpamError(`Failed to remove comment: ${error.message}`);
      setIsLoadingComments(false);
    }
  };

  // Function to hide a reported comment from the main view
  const handleHideReportedComment = (commentUniqueId) => {
    try {
      // Get current hidden comments from localStorage
      const hiddenCommentsStr = localStorage.getItem('hiddenReportedComments') || '[]';
      const hiddenCommentsIds = JSON.parse(hiddenCommentsStr);

      // Add this comment to the hidden list if not already there
      if (!hiddenCommentsIds.includes(commentUniqueId)) {
        hiddenCommentsIds.push(commentUniqueId);
        
        // Save updated list back to localStorage
        localStorage.setItem('hiddenReportedComments', JSON.stringify(hiddenCommentsIds));
      }

      // Find the comment in reported comments list
      const commentToHide = reportedComments.find(c => c.uniqueId === commentUniqueId);

      if (commentToHide) {
        // Update state by moving the comment from main to hidden view
        setReportedComments(prevComments => 
          prevComments.filter(c => c.uniqueId !== commentUniqueId)
        );
        
        setHiddenReportedComments(prevHidden => 
          [...prevHidden, commentToHide].sort((a, b) => b.reportCount - a.reportCount)
        );

        setSuccessMessage('Comment hidden from main view');
        setTimeout(() => setSuccessMessage(''), 3000);
      }
    } catch (error) {
      // console.error('Error hiding comment:', error);
      setSpamError('Failed to hide comment. Please try again.');
      setTimeout(() => setSpamError(null), 3000);
    }
  };

  // Function to unhide a reported comment
  const handleUnhideReportedComment = (commentUniqueId) => {
    try {
      // Get current hidden comments from localStorage
      const hiddenCommentsStr = localStorage.getItem('hiddenReportedComments') || '[]';
      const hiddenCommentsIds = JSON.parse(hiddenCommentsStr);

      // Remove the comment ID from the hidden list
      const updatedHiddenComments = hiddenCommentsIds.filter(id => id !== commentUniqueId);

      // Save updated list back to localStorage
      localStorage.setItem('hiddenReportedComments', JSON.stringify(updatedHiddenComments));

      // Find the comment in hidden reported comments
      const commentToUnhide = hiddenReportedComments.find(c => c.uniqueId === commentUniqueId);

      if (commentToUnhide) {
        // Update state by moving the comment from hidden to main view
        setHiddenReportedComments(prevHidden => 
          prevHidden.filter(c => c.uniqueId !== commentUniqueId)
        );
        
        setReportedComments(prevReported => 
          [...prevReported, commentToUnhide].sort((a, b) => b.reportCount - a.reportCount)
        );

        setSuccessMessage('Comment restored to main view');
        setTimeout(() => setSuccessMessage(''), 3000);
      }
    } catch (error) {
      // console.error('Error unhiding comment:', error);
      setSpamError('Failed to unhide comment. Please try again.');
      setTimeout(() => setSpamError(null), 3000);
    }
  };

  // Add the profile picture approval and rejection functions after the other field handlers

  // Handle approving a profile picture
  const handleApproveProfilePicture = async (userId) => {
    setError(null);
    setSuccessMessage('');

    const userProfile = pendingProfiles.find(p => p.id === userId);
    if (!userProfile) {
      // console.error("User profile not found in state for ID:", userId);
      setModerationError("Could not find user data to approve profile picture.");
      return;
    }

    // Check if the user has a pending photo URL
    if (!userProfile.pendingPhotoUrl) {
      // console.error("User has no pending profile picture:", userId);
      setModerationError("No pending profile picture found for this user.");
      return;
    }

    const pendingPhotoUrl = userProfile.pendingPhotoUrl;

    try {
      setIsLoadingModeration(true);
      
      // We'll store the approved photo URL here
      let approvedPhotoUrl = pendingPhotoUrl;
      
      // If we want to move the image to a different storage location
      // (optional but recommended for clear separation)
      try {
        // Extract info about the pending image
        const url = new URL(pendingPhotoUrl);
        const path = url.pathname.split('/o/')[1];
        
        if (path) {
          const decodedPath = decodeURIComponent(path.split('?')[0]);
          
          
          // Create a reference to the pending image
          const pendingImageRef = ref(storage, decodedPath);
          
          // Extract name from path to use for approved image
          // Get just the file name without path
          const fileName = decodedPath.split('/').pop();
          
          // Create timestamp to ensure uniqueness of approved image
          const timestamp = Date.now();
          
          // Create new path for approved image
          // Change pendingProfilePictures to approvedProfilePictures
          const approvedPath = `approvedProfilePictures/${userId}_${timestamp}_${fileName}`;
          const approvedImageRef = ref(storage, approvedPath);
          
          // First, download the image from firebase storage
          const response = await fetch(pendingPhotoUrl);
          const blob = await response.blob();
          
          // Upload to the approved location
          await uploadBytes(approvedImageRef, blob);
          
          // Get the download URL for the approved image
          approvedPhotoUrl = await getDownloadURL(approvedImageRef);
          
          
          // Delete the pending image (optional cleanup)
          try {
            await deleteObject(pendingImageRef);
            
          } catch (deleteError) {
            // console.error("Error deleting pending image after approval:", deleteError);
            // Continue even if delete fails
          }
        }
      } catch (storageError) {
        // console.error("Error moving image to approved storage:", storageError);
        // Continue with the approval using original URL if storage operations fail
      }
      
      // Prepare the update payload
      const updateData = {
        photoUrl: approvedPhotoUrl, // Use the new URL if we moved the image, or the original URL if not
        pendingPhotoUrl: null,     // Clear the pending photo URL
      };

      // Check if other pending fields still need moderation
      let otherPendingExists = false;
      const credentials = userProfile.credentials || {};
      const fieldsToCheck = ['Status', 'Biography', 'YoutubeLink', 'TikTokLink', 'InstagramLink', 'TwitterLink'];
      
      fieldsToCheck.forEach(f => {
        const checkPendingField = `pending${f}`;
        if (
          credentials[checkPendingField] !== null &&
          credentials[checkPendingField] !== undefined &&
          Array.isArray(credentials[checkPendingField]) &&
          credentials[checkPendingField][1] === false
        ) {
          otherPendingExists = true;
        }
      });

      // If no other pending fields have values, set needsModeration to false
      if (!otherPendingExists) {
        updateData.needsModeration = false;
      }

      // Update the user document
      const userDocRef = doc(firestore, 'users', userId);
      await updateDoc(userDocRef, updateData);

      setSuccessMessage(`Profile picture approved successfully for user ${userProfile.credentials?.handle || userId}!`);
      
      // Refresh the data to reflect the change
      await fetchPendingProfiles();

      // Auto-hide success message
      setTimeout(() => setSuccessMessage(''), 4000);
    } catch (err) {
      // console.error(`Error approving profile picture for user ${userId}:`, err);
      setModerationError(`Failed to approve profile picture. Please try again.`);
      // Auto-hide error message
      setTimeout(() => setModerationError(null), 5000);
    } finally {
      setIsLoadingModeration(false);
    }
  };

  // Handle rejecting a profile picture
  const handleRejectProfilePicture = async (userId) => {
    setError(null);
    setSuccessMessage('');

    const userProfile = pendingProfiles.find(p => p.id === userId);
    if (!userProfile) {
      // console.error("User profile not found in state for ID:", userId);
      setModerationError("Could not find user data to reject profile picture.");
      return;
    }

    // Check if the user has a pending photo URL
    if (!userProfile.pendingPhotoUrl) {
      // console.error("User has no pending profile picture:", userId);
      setModerationError("No pending profile picture found for this user.");
      return;
    }

    const pendingPhotoUrl = userProfile.pendingPhotoUrl;

    try {
      setIsLoadingModeration(true);

      // Try to delete the file from storage first
      try {
        // Extract info about the pending image
        const url = new URL(pendingPhotoUrl);
        const path = url.pathname.split('/o/')[1];
        
        if (path) {
          const decodedPath = decodeURIComponent(path.split('?')[0]);
          
          
          // Create a reference to the pending image
          const pendingImageRef = ref(storage, decodedPath);
          
          // Delete the pending image
          await deleteObject(pendingImageRef);
          
        }
      } catch (storageError) {
        // console.error("Error deleting rejected pending image from storage:", storageError);
        // Continue with the rejection process even if delete fails
      }

      // Prepare the update payload
      const updateData = {
        pendingPhotoUrl: null,  // Clear the pending photo URL
      };

      // Check if other pending fields still need moderation
      let otherPendingExists = false;
      const credentials = userProfile.credentials || {};
      const fieldsToCheck = ['Status', 'Biography', 'YoutubeLink', 'TikTokLink', 'InstagramLink', 'TwitterLink'];
      
      fieldsToCheck.forEach(f => {
        const checkPendingField = `pending${f}`;
        if (
          credentials[checkPendingField] !== null &&
          credentials[checkPendingField] !== undefined &&
          Array.isArray(credentials[checkPendingField]) &&
          credentials[checkPendingField][1] === false
        ) {
          otherPendingExists = true;
        }
      });

      // If no other pending fields have values, set needsModeration to false
      if (!otherPendingExists) {
        updateData.needsModeration = false;
      }

      // Update the user document
      const userDocRef = doc(firestore, 'users', userId);
      await updateDoc(userDocRef, updateData);

      setSuccessMessage(`Profile picture rejected successfully for user ${userProfile.credentials?.handle || userId}!`);
      
      // Refresh the data to reflect the change
      await fetchPendingProfiles();

      // Auto-hide success message
      setTimeout(() => setSuccessMessage(''), 4000);
    } catch (err) {
      // console.error(`Error rejecting profile picture for user ${userId}:`, err);
      setModerationError(`Failed to reject profile picture. Please try again.`);
      // Auto-hide error message
      setTimeout(() => setModerationError(null), 5000);
    } finally {
      setIsLoadingModeration(false);
    }
  };

  // Show admin login form if not authenticated
  if (showLoginForm && !isAdminAuthenticated) {
    return (
      <div className="app-container" style={{}}>
        <div
          className="main-column explore-container"
          style={{ 
            scrollbarWidth: 'thin', 
            scrollbarColor: 'gold transparent',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: '#222',
              borderRadius: '15px',
              padding: '40px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
              border: '2px solid gold',
              maxWidth: '400px',
              width: '90%',
              textAlign: 'center'
            }}
          >
            <div style={{ marginBottom: '30px' }}>
              <i 
                className="fa-solid fa-shield-halved" 
                style={{ 
                  fontSize: '48px', 
                  color: 'gold',
                  marginBottom: '20px',
                  display: 'block'
                }}
              ></i>
              <h2 style={{ color: 'gold', marginBottom: '10px' }}>
                Admin Access Required
              </h2>
              <p style={{ color: '#ccc', fontSize: '14px' }}>
                Enter the admin password to continue
              </p>
            </div>

            <form onSubmit={handleAdminLogin}>
              <div style={{ marginBottom: '15px' }}>
                <input
                  type="text"
                  value={loginForm.username}
                  onChange={(e) => setLoginForm({...loginForm, username: e.target.value})}
                  placeholder="Admin username"
                  style={{
                    width: '93%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: loginError ? '2px solid #ff0050' : '2px solid #444',
                    backgroundColor: '#333',
                    color: 'white',
                    fontSize: '16px',
                    outline: 'none',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'gold'}
                  onBlur={(e) => e.target.style.borderColor = loginError ? '#ff0050' : '#444'}
                  autoFocus
                  disabled={isLoggingIn}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <input
                  type="password"
                  value={loginForm.password}
                  onChange={(e) => setLoginForm({...loginForm, password: e.target.value})}
                  placeholder="Admin password"
                  style={{
                    width: '93%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: loginError ? '2px solid #ff0050' : '2px solid #444',
                    backgroundColor: '#333',
                    color: 'white',
                    fontSize: '16px',
                    outline: 'none',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'gold'}
                  onBlur={(e) => e.target.style.borderColor = loginError ? '#ff0050' : '#444'}
                  disabled={isLoggingIn}
                />
              </div>

              {loginError && (
                <div
                  style={{
                    backgroundColor: 'rgba(255, 0, 80, 0.2)',
                    border: '1px solid #ff0050',
                    color: '#ff0050',
                    padding: '10px',
                    borderRadius: '5px',
                    marginBottom: '20px',
                    fontSize: '14px'
                  }}
                >
                  <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: '8px' }}></i>
                  {loginError}
                </div>
              )}

              <button
                type="submit"
                disabled={isLoggingIn || !loginForm.username || !loginForm.password}
                style={{
                  width: '100%',
                  padding: '12px',
                  backgroundColor: isLoggingIn ? '#666' : 'gold',
                  color: 'black',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: isLoggingIn ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: isLoggingIn ? 0.7 : 1
                }}
                onMouseOver={(e) => {
                  if (!isLoggingIn) {
                    e.target.style.backgroundColor = '#ffed4a';
                    e.target.style.transform = 'translateY(-2px)';
                  }
                }}
                onMouseOut={(e) => {
                  if (!isLoggingIn) {
                    e.target.style.backgroundColor = 'gold';
                    e.target.style.transform = 'translateY(0)';
                  }
                }}
              >
                {isLoggingIn ? (
                  <>
                    <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                    Authenticating...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-unlock" style={{ marginRight: '8px' }}></i>
                    Login to Dashboard
                  </>
                )}
              </button>
            </form>

            <div style={{ marginTop: '20px', fontSize: '12px', color: '#666' }}>
              <i className="fa-solid fa-info-circle" style={{ marginRight: '5px' }}></i>
              Authorized personnel only
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container" style={{}}>
      <div
        className="main-column explore-container"
        style={{ scrollbarWidth: 'thin', scrollbarColor: 'gold transparent' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h1
            style={{
              textAlign: 'center',
              color: 'gold',
              margin: 0,
              flex: 1
            }}
          >
            Admin Dashboard
          </h1>
          <button
            onClick={handleAdminLogout}
            style={{
              backgroundColor: 'transparent',
              border: '2px solid #ff0050',
              color: '#ff0050',
              padding: '8px 16px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#ff0050';
              e.target.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#ff0050';
            }}
          >
            <i className="fa-solid fa-sign-out-alt" style={{ marginRight: '8px' }}></i>
            Logout
          </button>
        </div>

        {/* Tabs navigation */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '30px',
            gap: '5px',
            borderBottom: '2px solid gold',
            paddingBottom: '10px',
          }}
        >
          {[
            { id: 'gameLookup', label: 'Chess Clip' },
            { id: 'spam', label: 'SPAM' },

            { id: 'profileModeration', label: 'Profile Moderation' }, // Add new tab

            { id: 'gameOfDay', label: 'Game Of The Day' },
            { id: 'testTab2', label: 'Daily Content' },
            { id: 'landingGames', label: 'Landing Games' },
            { id: 'featuredCreators', label: 'Featured Creators' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                backgroundColor: activeTab === tab.id ? 'gold' : 'transparent',
                color: activeTab === tab.id ? 'black' : 'gold',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '5px 5px 0 0',
                cursor: 'pointer',
                fontWeight: activeTab === tab.id ? 'bold' : 'normal',
                fontSize: '16px',
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab content */}
        <div
          className="dashboard-content"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '30px',
          }}
        >
          {/* Error and success messages */}
          {error && (
            <div
              style={{
                backgroundColor: 'rgba(255, 0, 0, 0.2)',
                border: '1px solid #ff0000',
                color: '#ff0000',
                padding: '10px',
                borderRadius: '5px',
              }}
            >
              {error}
            </div>
          )}

          {successMessage && (
            <div
              style={{
                backgroundColor: 'rgba(0, 255, 0, 0.2)',
                border: '1px solid #00ff00',
                color: '#00ff00',
                padding: '10px',
                borderRadius: '5px',
              }}
            >
              {successMessage}
            </div>
          )}

          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
              }}
            >
              <p style={{ color: 'white', fontSize: '18px' }}>Loading...</p>
            </div>
          ) : (
            <>
              {/* Game of the Day Tab */}
              {activeTab === 'gameOfDay' && (
                <section
                  className="featured-game-section"
                  style={{
                    backgroundColor: '#222',
                    borderRadius: '10px',
                    padding: '20px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                  }}
                >
                  <h2 style={{ marginBottom: '20px', color: '#ff0050' }}>
                    Game of the Day Management
                  </h2>

                  {/* Combined Game of the Day and History Section */}
                  <div
                    className="game-history-all"
                    style={{ marginBottom: '30px' }}
                  >
                    <div
                      style={{
                        backgroundColor: '#333',
                        padding: '15px',
                        borderRadius: '5px',
                        marginTop: '10px',
                        display: 'grid',
                        gridTemplateColumns:
                          'repeat(auto-fill, minmax(300px, 1fr))',
                        gap: '15px',

                        overflowY: 'auto',
                        overflowX: 'auto',
                      }}
                    >
                      {/* Message when no current Game of the Day is set but there are games in history */}
                      {!currentFeaturedId && gameHistory.length > 0 && (
                        <div
                          style={{
                            backgroundColor: '#444',
                            padding: '15px',
                            borderRadius: '5px',
                            gridColumn: '1 / -1',
                            textAlign: 'center',
                            color: '#ff0050',
                          }}
                        >
                          <p style={{ marginBottom: '10px' }}>
                            <i
                              className="fa-solid fa-triangle-exclamation"
                              style={{ marginRight: '10px' }}
                            ></i>
                            No Game of the Day is currently selected
                          </p>
                          <p>
                            Select a game from history or add a new game ID in
                            the form below.
                          </p>
                        </div>
                      )}

                      {/* Current Game of the Day (if exists) */}
                      {currentFeaturedId && (
                        <div
                          key={`current-${currentFeaturedId}`}
                          style={{
                            backgroundColor: '#1a3366', // Distinctive background for current game
                            padding: '15px',
                            borderRadius: '5px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            border: '2px solid gold', // Gold border to highlight current game
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: '#2a4377',
                              padding: '8px',
                              borderRadius: '4px',
                              marginBottom: '5px',
                              textAlign: 'center',
                            }}
                          >
                            <span
                              style={{
                                color: 'gold',
                                fontWeight: 'bold',
                                fontSize: '16px',
                              }}
                            >
                              Today's Game of the Day
                            </span>
                          </div>

                          <p
                            style={{
                              fontSize: '14px',
                              wordBreak: 'break-all',
                              color: '#ccc',
                              backgroundColor: '#284070',
                              padding: '8px',
                              borderRadius: '4px',
                            }}
                          >
                            <strong>ID:</strong> {currentFeaturedId}
                          </p>

                          <p
                            style={{
                              fontSize: '14px',
                              color: '#ccc',
                              backgroundColor: '#284070',
                              padding: '8px',
                              borderRadius: '4px',
                            }}
                          >
                            <strong>Date:</strong>{' '}
                            {new Date(gameDate).toLocaleDateString('en-US', {
                              weekday: 'long',
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            })}
                          </p>

                          <div
                            style={{
                              display: 'flex',
                              marginTop: '5px',
                              gap: '10px',
                            }}
                          >
                            <button
                              onClick={() =>
                                handleRemoveGameFromHistory(currentFeaturedId)
                              }
                              style={{
                                backgroundColor: '#ff0050',
                                color: 'white',
                                border: 'none',
                                padding: '8px 12px',
                                borderRadius: '3px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                opacity: '0.6', // Dimmed to indicate it's disabled
                              }}
                              disabled={true}
                              title="Cannot remove the current Game of the Day - set a new one first"
                            >
                              Remove
                            </button>
                          </div>

                          <div style={{ marginTop: '10px' }}>
                            <GameSummary
                              id={currentFeaturedId}
                              boardWidth={250}
                            />
                          </div>
                        </div>
                      )}

                      {/* History Games */}
                      {gameHistory.map((id, index) => {
                        // Skip if this is the current featured game (we already displayed it above)
                        if (id === currentFeaturedId) return null;

                        // Get the date for this historical game, if available
                        const gameHistoryDate = historyDates[id] || null;

                        return (
                          <div
                            key={id}
                            style={{
                              backgroundColor: '#444',
                              padding: '15px',
                              borderRadius: '5px',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '10px',
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: '#555',
                                padding: '8px',
                                borderRadius: '4px',
                                marginBottom: '5px',
                                textAlign: 'center',
                              }}
                            >
                              <span
                                style={{
                                  color: 'white',
                                  fontWeight: 'bold',
                                  fontSize: '16px',
                                }}
                              >
                                {index === 0
                                  ? "Yesterday's Game"
                                  : `Previous Game #${index}`}
                              </span>
                            </div>

                            <p
                              style={{
                                fontSize: '14px',
                                wordBreak: 'break-all',
                                color: '#ccc',
                                backgroundColor: '#535353',
                                padding: '8px',
                                borderRadius: '4px',
                              }}
                            >
                              <strong>ID:</strong> {id}
                            </p>

                            {gameHistoryDate && (
                              <p
                                style={{
                                  fontSize: '14px',
                                  color: '#ccc',
                                  backgroundColor: '#535353',
                                  padding: '8px',
                                  borderRadius: '4px',
                                }}
                              >
                                <strong>Date:</strong>{' '}
                                {new Date(gameHistoryDate).toLocaleDateString(
                                  'en-US',
                                  {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                  },
                                )}
                              </p>
                            )}

                            <div
                              style={{
                                display: 'flex',
                                gap: '10px',
                                marginTop: '5px',
                              }}
                            >
                              <button
                                onClick={() => setGameId(id)}
                                style={{
                                  backgroundColor: '#3066BE',
                                  color: 'white',
                                  border: 'none',
                                  padding: '8px 12px',
                                  borderRadius: '3px',
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                  flex: '1',
                                }}
                              >
                                Select for Today
                              </button>
                              <button
                                onClick={() => handleRemoveGameFromHistory(id)}
                                style={{
                                  backgroundColor: '#ff0050',
                                  color: 'white',
                                  border: 'none',
                                  padding: '8px 12px',
                                  borderRadius: '3px',
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                }}
                              >
                                Remove
                              </button>
                            </div>
                            <div style={{ marginTop: '10px' }}>
                              <GameSummary id={id} boardWidth={250} />
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {!currentFeaturedId && !gameHistory.length && (
                      <p>No games in history</p>
                    )}
                  </div>

                  {/* Divider */}
                  <div
                    style={{
                      margin: '30px 0',
                      height: '2px',
                      background:
                        'linear-gradient(to right, transparent, gold, transparent)',
                      position: 'relative',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: '-12px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: '#222',
                        padding: '0 15px',
                        color: 'gold',
                        fontSize: '16px',
                      }}
                    >
                      Set New Game of the Day
                    </div>
                  </div>

                  <form
                    onSubmit={handleGameOfDaySubmit}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '15px',
                      backgroundColor: '#333',
                      padding: '20px',
                      borderRadius: '5px',
                    }}
                  >
                    <h3 style={{ marginTop: 0 }}>Update Game of the Day</h3>

                    <div>
                      <label
                        htmlFor="gameId"
                        style={{ display: 'block', marginBottom: '5px' }}
                      >
                        Game ID:
                      </label>
                      <input
                        type="text"
                        id="gameId"
                        value={gameId}
                        onChange={(e) => setGameId(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '10px',
                          borderRadius: '5px',
                          border: '1px solid #555',
                          backgroundColor: '#444',
                          color: 'white',
                          fontSize: '16px',
                        }}
                        placeholder="Enter game ID (UUID format)"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="gameDate"
                        style={{ display: 'block', marginBottom: '5px' }}
                      >
                        Date:
                      </label>
                      <input
                        type="date"
                        id="gameDate"
                        value={gameDate}
                        onChange={(e) => setGameDate(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '10px',
                          borderRadius: '5px',
                          border: '1px solid #555',
                          backgroundColor: '#444',
                          color: 'white',
                          fontSize: '16px',
                        }}
                      />
                    </div>

                    {/* Preview toggle */}
                    <div>
                      <button
                        type="button"
                        onClick={togglePreview}
                        style={{
                          backgroundColor: '#555',
                          border: 'none',
                          padding: '10px 15px',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          color: 'white',
                        }}
                      >
                        {previewMode ? 'Hide Preview' : 'Show Preview'}
                      </button>
                    </div>

                    {/* Preview section */}
                    {previewMode && gameId && isValidGameId(gameId) && (
                      <div
                        style={{
                          marginTop: '10px',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <GameSummary id={gameId} boardWidth={300} />
                      </div>
                    )}

                    <button
                      type="submit"
                      disabled={isLoading}
                      style={{
                        backgroundColor: '#3066BE',
                        color: 'white',
                        border: 'none',
                        padding: '12px 20px',
                        borderRadius: '5px',
                        fontSize: '16px',
                        cursor: isLoading ? 'not-allowed' : 'pointer',
                        opacity: isLoading ? 0.7 : 1,
                      }}
                    >
                      {isLoading ? 'Updating...' : 'Update Game of the Day'}
                    </button>
                  </form>
                </section>
              )}

              {/* Landing Games Tab */}
              {activeTab === 'landingGames' && (
                <section
                  className="landing-games-section"
                  style={{
                    backgroundColor: '#222',
                    borderRadius: '10px',
                    padding: '20px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                  }}
                >
                  <h2 style={{ marginBottom: '20px', color: '#ff0050' }}>Landing Games</h2>

                  {/* Current Landing Games List */}
                  <div
                    className="current-landing-games"
                    style={{ marginBottom: '30px' }}
                  >
                    {landingGames.length > 0 ? (
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns:
                            'repeat(auto-fill, minmax(300px, 1fr))',
                          gap: '20px',
                          marginTop: '15px',
                        }}
                      >
                        {landingGames.map((gameId, index) => (
                          <div
                            key={gameId}
                            style={{
                              backgroundColor: '#333',
                              padding: '15px',
                              borderRadius: '5px',
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            <div
                              style={{
                                marginBottom: '15px',
                              }}
                            >
                              <p
                                style={{
                                  fontWeight: 'bold',
                                  marginBottom: '5px',
                                  color: 'gold',
                                }}
                              >
                                Game #{index + 1}
                              </p>
                              <p
                                style={{
                                  fontSize: '14px',
                                  wordBreak: 'break-all',
                                  color: '#ccc',
                                  marginBottom: '10px',
                                }}
                              >
                                {gameId}
                              </p>
                              <button
                                onClick={() => handleRemoveLandingGame(gameId)}
                                style={{
                                  backgroundColor: '#ff0050',
                                  color: 'white',
                                  border: 'none',
                                  padding: '5px 10px',
                                  borderRadius: '5px',
                                  cursor: 'pointer',
                                }}
                              >
                                Remove
                              </button>
                            </div>
                            <GameSummary id={gameId} boardWidth={270} />
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p>No games added yet</p>
                    )}
                  </div>

                  {/* Add New Landing Game Form */}
                  <form
                    onSubmit={handleLandingGamesSubmit}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '15px',
                      backgroundColor: '#333',
                      padding: '20px',
                      borderRadius: '5px',
                    }}
                  >
                    <h3 style={{ marginTop: 0, color: 'gold' }}>Add New Landing Game</h3>

                    <div>
                      <label
                        htmlFor="newLandingGameId"
                        style={{ display: 'block', marginBottom: '5px', color: 'white' }}
                      >
                        Game ID:
                      </label>
                      <input
                        type="text"
                        id="newLandingGameId"
                        value={newLandingGameId}
                        onChange={(e) => setNewLandingGameId(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '10px',
                          borderRadius: '5px',
                          border: '1px solid #555',
                          backgroundColor: '#444',
                          color: 'white',
                          fontSize: '16px',
                        }}
                        placeholder="Enter game ID (UUID format)"
                      />
                    </div>

                    {/* Preview toggle */}
                    <div>
                      <button
                        type="button"
                        onClick={togglePreview}
                        style={{
                          backgroundColor: '#555',
                          border: 'none',
                          padding: '10px 15px',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          color: 'white',
                        }}
                      >
                        {previewMode ? 'Hide Preview' : 'Show Preview'}
                      </button>
                    </div>

                    {/* Preview section */}
                    {previewMode &&
                      newLandingGameId &&
                      isValidGameId(newLandingGameId) && (
                        <div
                          style={{
                            marginTop: '10px',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          <GameSummary id={newLandingGameId} boardWidth={270} />
                        </div>
                      )}

                    <button
                      type="submit"
                      disabled={isLoading}
                      style={{
                        backgroundColor: '#3066BE',
                        color: 'white',
                        border: 'none',
                        padding: '12px 20px',
                        borderRadius: '5px',
                        fontSize: '16px',
                        cursor: isLoading ? 'not-allowed' : 'pointer',
                        opacity: isLoading ? 0.7 : 1,
                      }}
                    >
                      {isLoading ? 'Adding...' : 'Add Game to Landing'}
                    </button>
                  </form>
                </section>
              )}

              {/* Featured Creators Tab */}
              {activeTab === 'featuredCreators' && (
                <section
                  className="featured-creators-section"
                  style={{
                    backgroundColor: '#222',
                    borderRadius: '10px',
                    padding: '20px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                  }}
                >
                  <h2 style={{ marginBottom: '20px', color: '#ff0050' }}>Featured Creators</h2>

                  {/* Current Featured Creators List */}
                  <div
                    className="current-featured-creators"
                    style={{ marginBottom: '30px' }}
                  >
                    {featuredCreators.length > 0 ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '10px',
                          marginTop: '15px',
                        }}
                      >
                        {featuredCreators.map((creator, index) => (
                          <div
                            key={creator.username}
                            style={{
                              backgroundColor: '#333',
                              padding: '15px',
                              borderRadius: '5px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <div>
                              <p style={{ margin: '0', fontWeight: 'bold', color: 'gold' }}>
                                {creator.username}
                              </p>
                              <p
                                style={{
                                  margin: '5px 0 0',
                                  color: '#aaa',
                                  fontSize: '14px',
                                }}
                              >
                                Profile URL: {creator.profileUrl}
                              </p>
                            </div>
                            <button
                              onClick={() =>
                                handleRemoveCreator(creator.username)
                              }
                              style={{
                                backgroundColor: '#ff0050',
                                color: 'white',
                                border: 'none',
                                padding: '5px 10px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p>No featured creators added yet</p>
                    )}
                  </div>

                  {/* Add New Featured Creator Form */}
                  <form
                    onSubmit={handleFeaturedCreatorsSubmit}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '15px',
                      backgroundColor: '#333',
                      padding: '20px',
                      borderRadius: '5px',
                    }}
                  >
                    <h3 style={{ marginTop: 0, color: 'gold' }}>Add New Featured Creator</h3>

                    <div>
                      <label
                        htmlFor="newCreatorHandle"
                        style={{ display: 'block', marginBottom: '5px', color: 'white' }}
                      >
                        Creator Handle:
                      </label>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span
                          style={{
                            padding: '10px',
                            backgroundColor: '#444',
                            borderRadius: '5px 0 0 5px',
                            color: 'white',
                          }}
                        >
                          @
                        </span>
                        <input
                          type="text"
                          id="newCreatorHandle"
                          value={newCreatorHandle}
                          onChange={(e) => setNewCreatorHandle(e.target.value)}
                          style={{
                            flex: 1,
                            padding: '10px',
                            borderRadius: '0 5px 5px 0',
                            border: '1px solid #555',
                            backgroundColor: '#444',
                            color: 'white',
                            fontSize: '16px',
                            borderLeft: 'none',
                          }}
                          placeholder="username"
                        />
                      </div>
                    </div>

                    <div>
                      <label
                        htmlFor="newCreatorProfileUrl"
                        style={{ display: 'block', marginBottom: '5px', color: 'white' }}
                      >
                        Profile URL (optional):
                      </label>
                      <input
                        type="text"
                        id="newCreatorProfileUrl"
                        value={newCreatorProfileUrl}
                        onChange={(e) =>
                          setNewCreatorProfileUrl(e.target.value)
                        }
                        style={{
                          width: '100%',
                          padding: '10px',
                          borderRadius: '5px',
                          border: '1px solid #555',
                          backgroundColor: '#444',
                          color: 'white',
                          fontSize: '16px',
                        }}
                        placeholder="/profile/username (defaults to this format if empty)"
                      />
                    </div>

                    <button
                      type="submit"
                      disabled={isLoading}
                      style={{
                        backgroundColor: '#3066BE',
                        color: 'white',
                        border: 'none',
                        padding: '12px 20px',
                        borderRadius: '5px',
                        fontSize: '16px',
                        cursor: isLoading ? 'not-allowed' : 'pointer',
                        opacity: isLoading ? 0.7 : 1,
                      }}
                    >
                      {isLoading ? 'Adding...' : 'Add Featured Creator'}
                    </button>
                  </form>
                </section>
              )}

              {/* SPAM Tab */}
              {activeTab === 'spam' && (
                <section
                  className="spam-section"
                  style={{
                    backgroundColor: '#222',
                    borderRadius: '10px',
                    padding: '20px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                  }}
                >
                  <h2 style={{ marginBottom: '20px', color: '#ff0050' }}>
                    Content Moderation - SPAM Management
                  </h2>

                  {/* Content type tabs (GAMES/COMMENTS) */}
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      marginBottom: '20px',
                      borderBottom: '2px solid #333',
                      paddingBottom: '10px'
                    }}
                  >
                    <button
                      onClick={() => setSpamContentType('games')}
                      style={{
                        backgroundColor: spamContentType === 'games' ? '#ff0050' : '#444',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '5px 5px 0 0',
                        cursor: 'pointer',
                        fontWeight: spamContentType === 'games' ? 'bold' : 'normal',
                        fontSize: '16px',
                      }}
                    >
                      GAMES
                    </button>
                    <button
                      onClick={() => setSpamContentType('comments')}
                      style={{
                        backgroundColor: spamContentType === 'comments' ? '#ff0050' : '#444',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '5px 5px 0 0',
                        cursor: 'pointer',
                        fontWeight: spamContentType === 'comments' ? 'bold' : 'normal',
                        fontSize: '16px',
                      }}
                    >
                      COMMENTS
                    </button>
                  </div>

                  {/* GAMES CONTENT */}
                  {spamContentType === 'games' && (
                    <>
                      {/* Dislike threshold control */}
                  <div
                    style={{
                      marginBottom: '20px',
                          backgroundColor: '#333',
                          padding: '15px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '15px',
                    }}
                  >
                    <button
                      onClick={() => setActiveSpamTab('main')}
                      style={{
                        backgroundColor:
                          activeSpamTab === 'main' ? '#ff0050' : '#444',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontWeight:
                          activeSpamTab === 'main' ? 'bold' : 'normal',
                        fontSize: '16px',
                      }}
                    >
                      Main ({spamGames.length})
                    </button>
                    <button
                      onClick={() => setActiveSpamTab('hidden')}
                      style={{
                        backgroundColor:
                          activeSpamTab === 'hidden' ? '#555' : '#444',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontWeight:
                          activeSpamTab === 'hidden' ? 'bold' : 'normal',
                        fontSize: '16px',
                      }}
                    >
                      Hidden ({hiddenSpamGames.length})
                    </button>
                        <label
                          htmlFor="dislikeThreshold"
                          style={{ color: 'white', fontWeight: 'bold' }}
                        >
                          Dislike Threshold:
                        </label>
                        <input
                          type="number"
                          id="dislikeThreshold"
                          min="1"
                          max="100"
                          value={dislikeThreshold}
                          onChange={(e) =>
                            setDislikeThreshold(parseInt(e.target.value) || 1)
                          }
                          style={{
                            width: '70px',
                            padding: '8px',
                            borderRadius: '4px',
                            border: '1px solid #555',
                            backgroundColor: '#444',
                            color: 'white',
                            fontSize: '16px',
                          }}
                        />
                        <button
                          onClick={fetchSpamGames}
                          style={{
                            backgroundColor: '#3066BE',
                            color: 'white',
                            border: 'none',
                            padding: '8px 15px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                          }}
                        >
                          Apply & Refresh
                        </button>
                        
                  </div>

                

                  {/* Error messages */}
                  {spamError && (
                    <div
                      style={{
                        backgroundColor: 'rgba(255, 0, 0, 0.2)',
                        border: '1px solid #ff0000',
                        color: '#ff0000',
                        padding: '10px',
                        borderRadius: '5px',
                        marginBottom: '20px',
                      }}
                    >
                      {spamError}
                    </div>
                  )}

                  {/* Loading indicator */}
                  {isLoadingSpam && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '200px',
                      }}
                    >
                      <p style={{ color: 'white', fontSize: '18px' }}>
                            Loading spam games...
                      </p>
                    </div>
                  )}

                  {/* Main spam content */}
                  {!isLoadingSpam && activeSpamTab === 'main' && (
                    <div>
                      {spamGames.length > 0 ? (
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns:
                              'repeat(auto-fill, minmax(220px, 1fr))',
                            gap: '20px',
                            marginTop: '15px',
                          }}
                        >
                          {spamGames.map((game) => (
                            <div
                              key={game.id}
                              style={{
                                backgroundColor: '#333',
                                padding: '15px',
                                borderRadius: '5px',
                                display: 'flex',
                                flexDirection: 'column',
                                    width: '250px',
                              }}
                            >
                              <div
                                style={{
                                  marginBottom: '15px',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                }}
                              >
                                <div>
                                  <span
                                    style={{
                                      backgroundColor: '#ff0050',
                                      color: 'white',
                                      padding: '3px 8px',
                                      borderRadius: '12px',
                                      fontSize: '14px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {game.dislikeCount}{' '}
                                    {game.dislikeCount === 1
                                      ? 'Dislike'
                                      : 'Dislikes'}
                                  </span>
                                      
                                </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                    
                                  <button
                                    onClick={() =>
                                      handleHideFromSpamView(game.id)
                                    }
                                    style={{
                                      backgroundColor: '#555',
                                      color: 'white',
                                      border: 'none',
                                      padding: '5px 10px',
                                      borderRadius: '5px',
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      marginLeft: '5px',
                                    }}
                                    title="Hide from main view"
                                  >
                                    <i className="fa-solid fa-eye-slash"></i>
                                      </button>

                                      <button
                                    onClick={() =>
                                      handleRemoveGameFromDatabase(game.id)
                                    }
                                    style={{
                                      backgroundColor: '#ff0050',
                                      color: 'white',
                                      border: 'none',
                                      padding: '8px 10px',
                                      borderRadius: '5px',
                                      cursor: 'pointer',
                                      fontSize: '14px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: '5px',
                                    }}
                                  >
                                    <i className="fa-solid fa-trash-can"></i>
                                    Delete
                                  </button>
                                </div>
                              </div>

                              <p
                                style={{
                                  fontSize: '12px',
                                  wordBreak: 'break-all',
                                  color: '#aaa',
                                  marginBottom: '10px',
                                }}
                              >
                                ID: {game.id}
                              </p>

                                  <div style={{ marginBottom: '15px', }}>
                                <GameSummary
                                  id={game.id}
                                  boardWidth={200}
                                  onClick={() =>
                                    handleOpenGameInNewTab(game.id)
                                  }
                                />
                              </div>

                                  
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p
                          style={{
                            color: 'white',
                            textAlign: 'center',
                            padding: '20px',
                            backgroundColor: '#333',
                            borderRadius: '5px',
                          }}
                        >
                              No spam games found with {dislikeThreshold} or more
                          dislikes.
                        </p>
                      )}
                    </div>
                  )}

                  {/* Hidden spam content */}
                  {!isLoadingSpam && activeSpamTab === 'hidden' && (
                    <div>
                      {hiddenSpamGames.length > 0 ? (
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns:
                              'repeat(auto-fill, minmax(220px, 1fr))',
                            gap: '20px',
                            marginTop: '15px',
                          }}
                        >
                          {hiddenSpamGames.map((game) => (
                            <div
                              key={game.id}
                              style={{
                                backgroundColor: '#333',
                                padding: '15px',
                                borderRadius: '5px',
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <div
                                style={{
                                  marginBottom: '15px',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                }}
                              >
                                <div>
                                  <span
                                    style={{
                                      backgroundColor: '#666',
                                      color: 'white',
                                      padding: '3px 8px',
                                      borderRadius: '12px',
                                      fontSize: '14px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {game.dislikeCount}{' '}
                                    {game.dislikeCount === 1
                                      ? 'Dislike'
                                      : 'Dislikes'}
                                  </span>
                                </div>
                                <div>
                                  <button
                                    onClick={() =>
                                      handleUnhideFromSpamView(game.id)
                                    }
                                    style={{
                                      backgroundColor: '#3066BE',
                                      color: 'white',
                                      border: 'none',
                                      padding: '5px 10px',
                                      borderRadius: '5px',
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      marginLeft: '5px',
                                    }}
                                    title="Restore to main view"
                                  >
                                    <i className="fa-solid fa-eye"></i>
                                  </button>
                                </div>
                              </div>

                              <p
                                style={{
                                  fontSize: '12px',
                                  wordBreak: 'break-all',
                                  color: '#aaa',
                                  marginBottom: '10px',
                                }}
                              >
                                ID: {game.id}
                              </p>

                              <div style={{ marginBottom: '15px' }}>
                                <GameSummary
                                  id={game.id}
                                  boardWidth={200}
                                  onClick={() =>
                                    handleOpenGameInNewTab(game.id)
                                  }
                                />
                              </div>

                              <button
                                onClick={() =>
                                  handleRemoveGameFromDatabase(game.id)
                                }
                                style={{
                                  backgroundColor: '#ff0050',
                                  color: 'white',
                                  border: 'none',
                                  padding: '8px 10px',
                                  borderRadius: '5px',
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '5px',
                                }}
                              >
                                <i className="fa-solid fa-trash-can"></i>
                                Remove from Database
                              </button>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p
                          style={{
                            color: 'white',
                            textAlign: 'center',
                            padding: '20px',
                            backgroundColor: '#333',
                            borderRadius: '5px',
                          }}
                        >
                              No hidden spam games found.
                            </p>
                          )}
                        </div>
                      )}
                    </>
                  )}
                  
                  {/* COMMENTS CONTENT */}
                  {spamContentType === 'comments' && (
                    <div>
                      {/* Report threshold control */}
                      <div
                        style={{
                          marginBottom: '20px',
                          backgroundColor: '#333',
                          padding: '15px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '15px',
                        }}
                      >
                       <button
                          onClick={() => setActiveSpamTab('main')}
                          style={{
                            backgroundColor:
                              activeSpamTab === 'main' ? '#ff0050' : '#444',
                            color: 'white',
                            border: 'none',
                            padding: '10px 20px',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontWeight:
                              activeSpamTab === 'main' ? 'bold' : 'normal',
                            fontSize: '16px',
                          }}
                        >
                          Main ({reportedComments.length})
                        </button>
                        <button
                          onClick={() => setActiveSpamTab('hidden')}
                          style={{
                            backgroundColor:
                              activeSpamTab === 'hidden' ? '#555' : '#444',
                            color: 'white',
                            border: 'none',
                            padding: '10px 20px',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontWeight:
                              activeSpamTab === 'hidden' ? 'bold' : 'normal',
                            fontSize: '16px',
                          }}
                        >
                          Hidden ({hiddenReportedComments.length})
                        </button>
                        <label
                          htmlFor="reportThreshold"
                          style={{ color: 'white', fontWeight: 'bold' }}
                        >
                          Report Threshold:
                        </label>
                        <input
                          type="number"
                          id="reportThreshold"
                          min="1"
                          max="100"
                          value={reportThreshold}
                          onChange={(e) =>
                            setReportThreshold(parseInt(e.target.value) || 1)
                          }
                          style={{
                            width: '70px',
                            padding: '8px',
                            borderRadius: '4px',
                            border: '1px solid #555',
                            backgroundColor: '#444',
                            color: 'white',
                            fontSize: '16px',
                          }}
                        />
                        <button
                          onClick={fetchReportedComments}
                          style={{
                            backgroundColor: '#3066BE',
                            color: 'white',
                            border: 'none',
                            padding: '8px 15px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                          }}
                        >
                          Apply & Refresh
                        </button>
                      </div>
                    

                      {/* Error messages */}
                      {spamError && (
                        <div
                          style={{
                            backgroundColor: 'rgba(255, 0, 0, 0.2)',
                            border: '1px solid #ff0000',
                            color: '#ff0000',
                            padding: '10px',
                            borderRadius: '5px',
                            marginBottom: '20px',
                          }}
                        >
                          {spamError}
                        </div>
                      )}

                      {/* Loading indicator */}
                      {isLoadingComments && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100px',
                          }}
                        >
                          <p style={{ color: 'white', fontSize: '16px' }}>
                            Loading reported comments...
                          </p>
                        </div>
                      )}

                      {/* MAIN TAB: Display reported comments */}
                      {!isLoadingComments && activeSpamTab === 'main' && (
                        <div>
                          {reportedComments.length > 0 ? (
                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr',
                                gap: '20px',
                              }}
                            >
                              {reportedComments.map((comment) => (
                                <div
                                  key={comment.uniqueId}
                                  style={{
                                    backgroundColor: '#333',
                                    padding: '15px',
                                    borderRadius: '5px',
                                  }}
                                >
                                  <div
                                    style={{
                                      marginBottom: '10px',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: '#ff0050',
                                        color: 'white',
                                        padding: '3px 8px',
                                        borderRadius: '12px',
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      {comment.reportCount}{' '}
                                      {comment.reportCount === 1
                                        ? 'Report'
                                        : 'Reports'}
                                    </span>
                                     <span style={{ color: 'white', fontSize: '12px' }}>Game ID: {comment.gameId}</span>
                                    <span style={{ color: 'white', fontSize: '12px' }}>Comment Index: {comment.commentIndex}</span>
                                    

                                    <button
                                      onClick={() => handleOpenGameInNewTab(comment.gameId)}
                                      style={{
                                        backgroundColor: '#3066BE',
                                        color: 'white',
                                        border: 'none',
                                        padding: '8px 15px',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                      }}
                                    >
                                      <i className="fa-solid fa-chess-board" style={{ marginRight: '5px' }}></i>
                                      View Game
                                    </button>

                                    <button
                                      onClick={() => handleHideReportedComment(comment.uniqueId)}
                                      style={{
                                        backgroundColor: '#555',
                                        color: 'white',
                                        border: 'none',
                                        padding: '5px 10px',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                        fontSize: '12px',
                                      }}
                                      title="Hide from main view"
                                    >
                                      <i className="fa-solid fa-eye-slash"></i>
                                    </button>
                                    
                                    
                                    <button
                                      onClick={() => handleRemoveCommentFromDatabase(comment.gameId, comment.commentIndex)}
                                      style={{
                                        backgroundColor: '#ff0050',
                                        color: 'white',
                                        border: 'none',
                                        padding: '8px 15px',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                      }}
                                    >
                                      <i className="fa-solid fa-trash-can" style={{ marginRight: '5px' }}></i>
                                      Delete Comment
                                    </button>
                                  </div>

                                  <div
                                    style={{
                                      marginBottom: '10px',
                                      padding: '10px',
                                      backgroundColor: '#444',
                                      borderRadius: '5px',
                                    }}
                                  >
                                    <div style={{ marginBottom: '5px' }}>
                                      <span style={{ color: 'gold', fontWeight: 'bold' }}>
                                        @{comment.username || 'unknown'}:
                                      </span>
                                    </div>
                                    <div style={{ color: 'white' }}>
                                      {comment.content}
                                    </div>
                                  </div>

                                </div>
                              ))}
                            </div>
                          ) : (
                            <p
                              style={{
                                color: 'white',
                                textAlign: 'center',
                                padding: '20px',
                                backgroundColor: '#333',
                                borderRadius: '5px',
                              }}
                            >
                              No reported comments found with {reportThreshold} or more
                              reports.
                            </p>
                          )}
                        </div>
                      )}
                      
                      {/* HIDDEN TAB: Display hidden reported comments */}
                      {!isLoadingComments && activeSpamTab === 'hidden' && (
                        <div>
                          {hiddenReportedComments.length > 0 ? (
                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr',
                                gap: '20px',
                              }}
                            >
                              {hiddenReportedComments.map((comment) => (
                                <div
                                  key={comment.uniqueId}
                                  style={{
                                    backgroundColor: '#333',
                                    padding: '15px',
                                    borderRadius: '5px',
                                  }}
                                >
                                  <div
                                    style={{
                                      marginBottom: '10px',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: '#666',
                                        color: 'white',
                                        padding: '3px 8px',
                                        borderRadius: '12px',
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      {comment.reportCount}{' '}
                                      {comment.reportCount === 1
                                        ? 'Report'
                                        : 'Reports'}
                                    </span>
                                    
                                    <button
                                      onClick={() => handleUnhideReportedComment(comment.uniqueId)}
                                      style={{
                                        backgroundColor: '#3066BE',
                                        color: 'white',
                                        border: 'none',
                                        padding: '5px 10px',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                        fontSize: '12px',
                                      }}
                                      title="Restore to main view"
                                    >
                                      <i className="fa-solid fa-eye"></i>
                                    </button>
                                  </div>

                                  <div
                                    style={{
                                      marginBottom: '10px',
                                      padding: '10px',
                                      backgroundColor: '#444',
                                      borderRadius: '5px',
                                    }}
                                  >
                                    <div style={{ marginBottom: '5px' }}>
                                      <span style={{ color: 'gold', fontWeight: 'bold' }}>
                                        @{comment.username || 'unknown'}:
                                      </span>
                                    </div>
                                    <div style={{ color: 'white' }}>
                                      {comment.content}
                                    </div>
                                  </div>

                                  <div style={{ fontSize: '12px', color: '#aaa' }}>
                                    <div>Game ID: {comment.gameId}</div>
                                    <div>Comment Index: {comment.commentIndex}</div>
                                  </div>
                                  
                                  <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                                    <button
                                      onClick={() => handleOpenGameInNewTab(comment.gameId)}
                                      style={{
                                        backgroundColor: '#3066BE',
                                        color: 'white',
                                        border: 'none',
                                        padding: '8px 15px',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                      }}
                                    >
                                      <i className="fa-solid fa-chess-board" style={{ marginRight: '5px' }}></i>
                                      View Game
                                    </button>
                                    
                                    <button
                                      onClick={() => handleRemoveCommentFromDatabase(comment.gameId, comment.commentIndex)}
                                      style={{
                                        backgroundColor: '#ff0050',
                                        color: 'white',
                                        border: 'none',
                                        padding: '8px 15px',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                      }}
                                    >
                                      <i className="fa-solid fa-trash-can" style={{ marginRight: '5px' }}></i>
                                      Delete Comment
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p
                              style={{
                                color: 'white',
                                textAlign: 'center',
                                padding: '20px',
                                backgroundColor: '#333',
                                borderRadius: '5px',
                              }}
                            >
                              No hidden reported comments.
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </section>
              )}

              {/* Profile Moderation Tab */}
              {activeTab === 'profileModeration' && (
                <section className="profile-moderation-section" style={{
                  backgroundColor: '#222',
                  borderRadius: '10px',
                  padding: '20px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
                }}>
                  <h2 style={{ marginBottom: '20px', color: '#ff0050' }}>Profile Content Moderation</h2>

                  {/* Loading and Error States */}
                  {moderationError && (
                    <div style={{
                      backgroundColor: 'rgba(255, 0, 0, 0.2)',
                      border: '1px solid #ff0000',
                      color: '#ff0000',
                      padding: '10px',
                      borderRadius: '5px',
                      marginBottom: '15px'
                    }}>
                      {moderationError}
                    </div>
                  )}
                  {successMessage && ( // Display success messages here as well
                    <div style={{
                      backgroundColor: 'rgba(0, 255, 0, 0.2)',
                      border: '1px solid #00ff00',
                      color: '#00ff00',
                      padding: '10px',
                      borderRadius: '5px',
                      marginBottom: '15px'
                    }}>
                      {successMessage}
                    </div>
                  )}


                  {isLoadingModeration ? (
                    <div style={{ textAlign: 'center', color: 'white', padding: '30px' }}>Loading profiles for moderation...</div>
                  ) : pendingProfiles.length === 0 ? (
                    <div style={{
                      textAlign: 'center',
                      color: 'white',
                      padding: '30px',
                      backgroundColor: '#333',
                      borderRadius: '5px'
                    }}>
                      No profiles currently require moderation.
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                      {pendingProfiles.map(userProfile => (
                        <div key={userProfile.id} style={{
                          backgroundColor: '#333',
                          padding: '20px',
                          borderRadius: '8px',
                          border: '1px solid #444'
                        }}>
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '15px',
                            borderBottom: '1px solid #555',
                            paddingBottom: '10px'
                          }}>
                            <h3 style={{
                              color: 'gold',
                              margin: '0'
                            }}>
                              User: @{userProfile.credentials?.handle || userProfile.id}
                            </h3>
                            <div style={{ display: 'flex', gap: '10px' }}>
                              <button
                                onClick={() => handleApproveAllFields(userProfile.id, userProfile)}
                                style={{
                                  backgroundColor: '#4CAF50',
                                  color: 'white',
                                  border: 'none',
                                  padding: '10px 20px',
                                  borderRadius: '4px',
                                  cursor: 'pointer',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}
                              >
                                APPROVE ALL
                              </button>
                              <button
                                onClick={() => handleRejectAllFields(userProfile.id, userProfile)}
                                style={{
                                  backgroundColor: '#f44336',
                                  color: 'white',
                                  border: 'none',
                                  padding: '10px 20px',
                                  borderRadius: '4px',
                                  cursor: 'pointer',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}
                              >
                                REJECT ALL
                              </button>
                            </div>
                          </div>

                          {/* Group the smaller fields together (status, social links) */}
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            {/* First group the shorter fields in a responsive grid */}
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                              gap: '10px'
                            }}>
                              {['Status', 'YoutubeLink', 'TikTokLink', 'InstagramLink', 'TwitterLink'].map(fieldKey => {
                                const pendingField = `pending${fieldKey}`;
                                const mainField = fieldKey.toLowerCase();

                                // Special handling for inconsistent field names
                                let safeMainField = mainField;
                                if (mainField === 'tiktoklink') safeMainField = 'tiktokLink';
                                else if (mainField === 'youtubelink') safeMainField = 'youtubeLink';
                                else if (mainField === 'instagramlink') safeMainField = 'instagramLink';
                                else if (mainField === 'twitterlink') safeMainField = 'twitterLink';

                                const pendingData = userProfile.credentials ? userProfile.credentials[pendingField] : null;

                                // Check if pending field exists and has [value, false] structure
                                if (pendingData && Array.isArray(pendingData) && pendingData.length === 2 && pendingData[1] === false) {
                                  const pendingValue = pendingData[0];
                                  const approvedValue = userProfile.credentials ? userProfile.credentials[safeMainField] : null;

                                  return (
                                    <div key={fieldKey} style={{
                                      backgroundColor: '#444',
                                      padding: '15px',
                                      borderRadius: '5px',
                                    }}>
                                      <strong style={{ color: 'white', fontSize: '16px' }}>{fieldKey}:</strong>
                                      <div style={{ marginLeft: '10px', color: '#ccc' }}>
                                        <span style={{ color: '#aaa' }}>Current:</span> {approvedValue || <i style={{ color: '#777' }}>None</i>}
                                      </div>
                                      <div style={{ marginLeft: '10px', color: 'gold', fontWeight: 'bold' }}>
                                        <span style={{ color: '#aaa' }}>Pending:</span> {pendingValue}
                                      </div>
                                      <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                                        <button
                                          onClick={() => handleApproveField(userProfile.id, mainField)}
                                          style={{
                                            backgroundColor: '#4CAF50',
                                            color: 'white',
                                            border: 'none',
                                            padding: '8px 12px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '14px'
                                          }}
                                        >
                                          Approve
                                        </button>
                                        <button
                                          onClick={() => handleRejectField(userProfile.id, mainField)}
                                          style={{
                                            backgroundColor: '#f44336',
                                            color: 'white',
                                            border: 'none',
                                            padding: '8px 12px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '14px'
                                          }}
                                        >
                                          Reject
                                        </button>
                                      </div>
                                    </div>
                                  );
                                }
                                return null; // Don't render if not pending
                              })}
                            </div>

                            {/* Biography field gets its own section since it can be longer */}
                            {['Biography'].map(fieldKey => {
                              const pendingField = `pending${fieldKey}`;
                              const mainField = fieldKey.toLowerCase();
                              const pendingData = userProfile.credentials ? userProfile.credentials[pendingField] : null;

                              if (pendingData && Array.isArray(pendingData) && pendingData.length === 2 && pendingData[1] === false) {
                                const pendingValue = pendingData[0];
                                const approvedValue = userProfile.credentials ? userProfile.credentials[mainField] : null;

                                return (
                                  <div key={fieldKey} style={{
                                    backgroundColor: '#444',
                                    padding: '15px',
                                    borderRadius: '5px',
                                    marginTop: '10px'
                                  }}>
                                    <strong style={{ color: 'white', fontSize: '16px' }}>{fieldKey}:</strong>
                                    <div style={{ marginLeft: '10px', color: '#ccc', margin: '10px 0' }}>
                                      <span style={{ color: '#aaa' }}>Current:</span><br />
                                      <div style={{ padding: '8px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '4px', marginTop: '5px' }}>
                                        {approvedValue || <i style={{ color: '#777' }}>None</i>}
                                      </div>
                                    </div>
                                    <div style={{ marginLeft: '10px', color: 'gold', fontWeight: 'bold', margin: '10px 0' }}>
                                      <span style={{ color: '#aaa' }}>Pending:</span><br />
                                      <div style={{ padding: '8px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '4px', marginTop: '5px' }}>
                                        {pendingValue}
                                      </div>
                                    </div>
                                    <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                                      <button
                                        onClick={() => handleApproveField(userProfile.id, mainField)}
                                        style={{
                                          backgroundColor: '#4CAF50',
                                          color: 'white',
                                          border: 'none',
                                          padding: '8px 12px',
                                          borderRadius: '4px',
                                          cursor: 'pointer',
                                          fontSize: '14px'
                                        }}
                                      >
                                        Approve
                                      </button>
                                      <button
                                        onClick={() => handleRejectField(userProfile.id, mainField)}
                                        style={{
                                          backgroundColor: '#f44336',
                                          color: 'white',
                                          border: 'none',
                                          padding: '8px 12px',
                                          borderRadius: '4px',
                                          cursor: 'pointer',
                                          fontSize: '14px'
                                        }}
                                      >
                                        Reject
                                      </button>
                                    </div>
                                  </div>
                                );
                              }
                              return null; // Don't render if not pending
                            })}
                          </div>

                          {/* Profile Picture Section */}
                          {userProfile.pendingPhotoUrl && (
                            <div style={{
                              marginBottom: '20px',
                              padding: '15px',
                              backgroundColor: 'rgba(0,0,0,0.3)',
                              borderRadius: '8px',
                              border: '1px solid rgba(255,215,0,0.3)'
                            }}>
                              <h4 style={{ marginBottom: '15px', color: 'gold' }}>
                                <i className="fa-solid fa-image" style={{ marginRight: '8px' }}></i>
                                Pending Profile Picture
                              </h4>
                              
                              <div style={{ 
                                display: 'flex', 
                                alignItems: 'flex-start',
                                gap: '20px',
                                flexWrap: 'wrap',
                                justifyContent: 'center'
                              }}>
                                {/* Current Photo */}
                                <div style={{ 
                                  display: 'flex', 
                                  flexDirection: 'column',
                                  alignItems: 'center'
                                }}>
                                  <div style={{ fontSize: '14px', marginBottom: '5px', color: '#aaa' }}>Current</div>
                                  <div style={{ 
                                    width: '120px', 
                                    height: '120px', 
                                    borderRadius: '50%',
                                    overflow: 'hidden',
                                    border: '2px solid #555',
                                    backgroundColor: '#121212'
                                  }}>
                                    <img 
                                      src={userProfile.photoUrl || chessslogo} 
                                      alt="Current profile" 
                                      style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                    />
                                  </div>
                                </div>
                                
                                {/* Arrow */}
                                <div style={{ 
                                  display: 'flex', 
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '24px',
                                  color: '#888',
                                  padding: '20px 0'
                                }}>
                                  <i className="fa-solid fa-arrow-right"></i>
                                </div>
                                
                                {/* Pending Photo */}
                                <div style={{ 
                                  display: 'flex', 
                                  flexDirection: 'column',
                                  alignItems: 'center'
                                }}>
                                  <div style={{ fontSize: '14px', marginBottom: '5px', color: '#aaa' }}>Pending</div>
                                  <div style={{ 
                                    width: '150px', 
                                    height: '150px', 
                                    borderRadius: '50%',
                                    overflow: 'hidden',
                                    border: '2px solid #ff0050',
                                    backgroundColor: '#121212'
                                  }}>
                                    <img 
                                      src={userProfile.pendingPhotoUrl} 
                                      alt="Pending profile" 
                                      style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                    />
                                  </div>
                                </div>
                              </div>
                              
                              <div style={{ 
                                display: 'flex', 
                                justifyContent: 'center',
                                gap: '15px',
                                marginTop: '20px'
                              }}>
                                <button 
                                  onClick={() => handleApproveProfilePicture(userProfile.id)}
                                  style={{
                                    backgroundColor: 'rgba(0,200,0,0.2)',
                                    color: '#0f0',
                                    border: '1px solid #0f0',
                                    padding: '8px 16px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                  }}
                                >
                                  <i className="fa-solid fa-check"></i>
                                  Approve
                                </button>
                                
                                <button 
                                  onClick={() => handleRejectProfilePicture(userProfile.id)}
                                  style={{
                                    backgroundColor: 'rgba(200,0,0,0.2)',
                                    color: '#f00',
                                    border: '1px solid #f00',
                                    padding: '8px 16px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                  }}
                                >
                                  <i className="fa-solid fa-xmark"></i>
                                  Reject
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </section>
              )}

              {/* Game Lookup Tab */}
              {activeTab === 'gameLookup' && (
                <section
                  style={{
                    backgroundColor: '#222',
                    borderRadius: '10px',
                    padding: '20px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                  }}
                >
                  <h2 style={{ marginBottom: '20px', color: '#ff0050' }}>
                    Super Admin Game Lookup
                  </h2>

                  <div
                    style={{
                      backgroundColor: '#333',
                      padding: '20px',
                      borderRadius: '5px',
                      marginBottom: '20px',
                    }}
                  >
                    <div
                      style={{
                        color: 'gold',
                        fontSize: '1.2rem',
                        marginBottom: '20px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                      }}
                    >
                      Enter a Game ID to inspect its data
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '15px',
                      }}
                    >
                      <input
                        type="text"
                        value={gameId}
                        onChange={(e) => setGameId(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '10px',
                          borderRadius: '5px',
                          border: '1px solid #555',
                          backgroundColor: '#444',
                          color: 'white',
                          fontSize: '16px',
                        }}
                        placeholder="Paste Game ID (UUID format)"
                      />

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '10px',
                        }}
                      >
                        <button
                          onClick={() => {
                            if (isValidGameId(gameId)) {
                              setPreviewMode(true);
                              setSuccessMessage(
                                'Game found! See preview below.',
                              );

                              // Auto-hide success message after 3 seconds
                              setTimeout(() => {
                                setSuccessMessage('');
                              }, 3000);
                            } else {
                              setError(
                                'Please enter a valid game ID (UUID format)',
                              );

                              // Auto-hide error message after 3 seconds
                              setTimeout(() => {
                                setError('');
                              }, 3000);
                            }
                          }}
                          style={{
                            padding: '10px 20px',
                            backgroundColor: 'gold',
                            color: 'black',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            fontSize: '16px',
                            transition: 'all 0.2s ease',
                          }}
                        >
                          SEARCH
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Game summary */}
                  {previewMode && gameId && isValidGameId(gameId) && (
                    <div
                      style={{
                        marginTop: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <h3 style={{ marginBottom: '15px', color: 'gold' }}>
                        Game Preview
                      </h3>
                      <GameSummary id={gameId} boardWidth={400} />

                      <button
                        onClick={() => {
                          handleTransformClick();
                        }}
                        style={{
                          marginTop: '20px',
                          padding: '10px 20px',
                          backgroundColor: '#ff0050',
                          color: 'white',
                          border: '2px solid gold',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          fontWeight: 'bold',
                          fontSize: '16px',
                          transition: 'all 0.2s ease',
                        }}

                      >
                        TRANSFORM
                      </button>
                    </div>
                  )}
                </section>
              )}

              {/* Test Tab 2 */}
              {activeTab === 'testTab2' && (
                <section
                  style={{
                    backgroundColor: '#222',
                    borderRadius: '10px',
                    padding: '20px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                  }}
                >
                  <h2 style={{ marginBottom: '20px', color: '#ff0050' }}>
                    Daily Content Management
                  </h2>
                  <p style={{ marginBottom: '20px', color: 'white' }}>
                    Manage daily tips, quotes, and facts that display on the
                    Explore page. The left text field is the current content
                    shown to users, and the right text field serves as a notepad
                    for storing future content ideas.
                  </p>

                  {/* Tip of the Day Row */}
                  <div
                    style={{
                      marginBottom: '30px',
                      backgroundColor: '#333',
                      padding: '20px',
                      borderRadius: '8px',
                    }}
                  >
                    <h3 style={{ color: 'gold', marginBottom: '15px' }}>
                      Tip of the Day
                    </h3>
                    <form onSubmit={handleTipOfDaySubmit}>
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 1fr',
                          gap: '20px',
                          marginBottom: '15px',
                        }}
                      >
                        <div>
                          <label
                            htmlFor="tipOfDay"
                            style={{ display: 'block', marginBottom: '5px', color: 'white' }}
                          >
                            Current Tip:
                          </label>
                          <textarea
                            id="tipOfDay"
                            value={tipOfDay}
                            onChange={(e) => setTipOfDay(e.target.value)}
                            style={{
                              width: '100%',
                              height: '120px',
                              padding: '10px',
                              borderRadius: '5px',
                              border: '1px solid #555',
                              backgroundColor: '#444',
                              color: 'white',
                              fontSize: '16px',
                              resize: 'vertical',
                            }}
                            placeholder="Enter the current tip of the day (supports HTML tags like <br />)"
                          ></textarea>
                        </div>
                        <div>
                          <label
                            htmlFor="tipNotepad"
                            style={{ display: 'block', marginBottom: '5px', color: 'white' }}
                          >
                            Notepad (for future tips):
                          </label>
                          <textarea
                            id="tipNotepad"
                            value={tipNotepad}
                            onChange={(e) => setTipNotepad(e.target.value)}
                            style={{
                              width: '100%',
                              height: '120px',
                              padding: '10px',
                              borderRadius: '5px',
                              border: '1px solid #555',
                              backgroundColor: '#444',
                              color: 'white',
                              fontSize: '16px',
                              resize: 'vertical',
                            }}
                            placeholder="Store future tips here for easy access"
                          ></textarea>
                        </div>
                      </div>
                      <div
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <button
                          type="submit"
                          disabled={isLoading}
                          style={{
                            backgroundColor: '#3066BE',
                            color: 'white',
                            border: 'none',
                            padding: '10px 20px',
                            borderRadius: '5px',
                            fontSize: '16px',
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            opacity: isLoading ? 0.7 : 1,
                          }}
                        >
                          {isLoading ? 'Saving...' : 'Save Tip'}
                        </button>
                      </div>
                    </form>
                  </div>

                  {/* Quote of the Day Row */}
                  <div
                    style={{
                      marginBottom: '30px',
                      backgroundColor: '#333',
                      padding: '20px',
                      borderRadius: '8px',
                    }}
                  >
                    <h3 style={{ color: 'gold', marginBottom: '15px' }}>
                      Quote of the Day
                    </h3>
                    <form onSubmit={handleQuoteOfDaySubmit}>
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 1fr',
                          gap: '20px',
                          marginBottom: '15px',
                        }}
                      >
                        <div>
                          <label
                            htmlFor="quoteOfDay"
                            style={{ display: 'block', marginBottom: '5px', color: 'white' }}
                          >
                            Current Quote:
                          </label>
                          <textarea
                            id="quoteOfDay"
                            value={quoteOfDay}
                            onChange={(e) => setQuoteOfDay(e.target.value)}
                            style={{
                              width: '100%',
                              height: '120px',
                              padding: '10px',
                              borderRadius: '5px',
                              border: '1px solid #555',
                              backgroundColor: '#444',
                              color: 'white',
                              fontSize: '16px',
                              resize: 'vertical',
                            }}
                            placeholder="Enter the current quote of the day (supports HTML tags like <br />)"
                          ></textarea>
                        </div>
                        <div>
                          <label
                            htmlFor="quoteNotepad"
                            style={{ display: 'block', marginBottom: '5px', color: 'white' }}
                          >
                            Notepad (for future quotes):
                          </label>
                          <textarea
                            id="quoteNotepad"
                            value={quoteNotepad}
                            onChange={(e) => setQuoteNotepad(e.target.value)}
                            style={{
                              width: '100%',
                              height: '120px',
                              padding: '10px',
                              borderRadius: '5px',
                              border: '1px solid #555',
                              backgroundColor: '#444',
                              color: 'white',
                              fontSize: '16px',
                              resize: 'vertical',
                            }}
                            placeholder="Store future quotes here for easy access"
                          ></textarea>
                        </div>
                      </div>
                      <div
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <button
                          type="submit"
                          disabled={isLoading}
                          style={{
                            backgroundColor: '#3066BE',
                            color: 'white',
                            border: 'none',
                            padding: '10px 20px',
                            borderRadius: '5px',
                            fontSize: '16px',
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            opacity: isLoading ? 0.7 : 1,
                          }}
                        >
                          {isLoading ? 'Saving...' : 'Save Quote'}
                        </button>
                      </div>
                    </form>
                  </div>

                  {/* Fact of the Day Row */}
                  <div
                    style={{
                      marginBottom: '30px',
                      backgroundColor: '#333',
                      padding: '20px',
                      borderRadius: '8px',
                    }}
                  >
                    <h3 style={{ color: 'gold', marginBottom: '15px' }}>
                      Fact of the Day
                    </h3>
                    <form onSubmit={handleFactOfDaySubmit}>
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 1fr',
                          gap: '20px',
                          marginBottom: '15px',
                        }}
                      >
                        <div>
                          <label
                            htmlFor="factOfDay"
                            style={{ display: 'block', marginBottom: '5px', color: 'white' }}
                          >
                            Current Fact:
                          </label>
                          <textarea
                            id="factOfDay"
                            value={factOfDay}
                            onChange={(e) => setFactOfDay(e.target.value)}
                            style={{
                              width: '100%',
                              height: '120px',
                              padding: '10px',
                              borderRadius: '5px',
                              border: '1px solid #555',
                              backgroundColor: '#444',
                              color: 'white',
                              fontSize: '16px',
                              resize: 'vertical',
                            }}
                            placeholder="Enter the current fact of the day (supports HTML tags like <br />)"
                          ></textarea>
                        </div>
                        <div>
                          <label
                            htmlFor="factNotepad"
                            style={{ display: 'block', marginBottom: '5px', color: 'white' }}
                          >
                            Notepad (for future facts):
                          </label>
                          <textarea
                            id="factNotepad"
                            value={factNotepad}
                            onChange={(e) => setFactNotepad(e.target.value)}
                            style={{
                              width: '100%',
                              height: '120px',
                              padding: '10px',
                              borderRadius: '5px',
                              border: '1px solid #555',
                              backgroundColor: '#444',
                              color: 'white',
                              fontSize: '16px',
                              resize: 'vertical',
                            }}
                            placeholder="Store future facts here for easy access"
                          ></textarea>
                        </div>
                      </div>
                      <div
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <button
                          type="submit"
                          disabled={isLoading}
                          style={{
                            backgroundColor: '#3066BE',
                            color: 'white',
                            border: 'none',
                            padding: '10px 20px',
                            borderRadius: '5px',
                            fontSize: '16px',
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            opacity: isLoading ? 0.7 : 1,
                          }}
                        >
                          {isLoading ? 'Saving...' : 'Save Fact'}
                        </button>
                      </div>
                    </form>
                  </div>
                </section>
              )}
            </>
          )}

          {/* Instructions section */}
          
        </div>
      </div>
    </div>
  );
};

// Map Redux state to component props
const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps, { getScreams })(AdminDashboard);
